///<reference path="../../../../components/short-cuts/models/short-cuts-group.model.ts"/>
module Meevo.Model {
    export interface AppointDetail {
        appointType: any;
        client: any;
        service: any;
        employee: any;
        originalEmployeeId: any;
    }
}

module Meevo.Plugins.AppointmentBook {
    import ClientTypeEnum = Meevo.Model.ClientTypeEnum;
    import AppointmentBookModalService = Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService;
    import GroupLevels = Meevo.Components.ShortCuts.GroupLevels;
    import IMeevoMessengerApiService = Meevo.Plugins.MeevoMessenger.IMeevoMessengerApiService;
    import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;

    export interface PassiveAlert {
        alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum;
        alertMessage: string;
    }

    export class AppointmentEditorService {
        private appointmentId;
        private isFromWaitList: boolean = false;
        private isFromStanding: boolean = false;
        private pendingAppointmentIdToDelete = null;
        private pendingIdToDelete = null;
        private updateAmPmTriggerHours = [0, 1, 2, 3, 4, 5, 21, 22, 23];
        private amPmIdentifier = "appointmentEditorAmPm";
        value = "";
        // some bs prop to save noteType to since it wasn't saving directly on scope
        local: any = {};
        currentAppointment: any = { services: [] };
        originalAppointment: any = {};
        showDatePicker: boolean = false;
        changeLogVisible: boolean = false;
        stepsListVisible: boolean = false;
        stepsVisible: boolean = false;
        historyVisible: boolean = false;
        changes: any[];
        currentDetail: any;
        genderPreferences: any;
        appointmentHistory: any;
        isInEdit: boolean = false;
        isInView: boolean = false;
        hasClientId: boolean = true;
        serviceAlerts: PassiveAlert[];
        payingClientMembershipAlerts: PassiveAlert[];
        clientMembershipAlerts: PassiveAlert[];
        payingClientPointsAlerts: PassiveAlert[];
        clientPointsAlerts: PassiveAlert[];
        clientAlerts: PassiveAlert[];
        clientGiftCardAlerts: PassiveAlert[];
        payingClientGiftCardAlerts: PassiveAlert[];
        clientNotes: any;
        payingClientAlerts: PassiveAlert[];
        payingClientNotes: any;
        allAggregatedNotes: { [key: string]: Meevo.Plugins.Note.INote[] | ng.IPromise<Meevo.Plugins.Note.INote[]> } = {};
        clientAlertMsg = [this.$translate.instant("CLIENT_ALERT_MISSINGPHONENUMBER"), this.$translate.instant("CLIENT_ALERT_MISSINGEMAILADDRESS"), this.$translate.instant("CLIENT_ALERT_MISSINGCONTACTINFO"), this.$translate.instant("CLIENT_ALERT_MISSINGREFERRAL"), this.$translate.instant("CLIENT_ALERT_HASNOTES"), this.$translate.instant("CLIENT_ALERT_HASACTIVEGIFTCARD"), this.$translate.instant("CLIENT_ALERT_MISSINGTEXTNOTIFICATIONS"), this.$translate.instant("CLIENT_ALERT_MISSINGTEXTMARKETING"), this.$translate.instant("CLIENT_ALERT_MISSINGEMAILMARKETING")];

        serviceAddOnPermission: boolean = false;
        clientReadPermission: boolean = false;
        clientWritePermission: boolean = false;
        clientCreditCardReadPermission: boolean = false;

        securityKeys = Meevo.Components.Common.SecurityKeys;
        securityParts = Meevo.Components.Common.SecurityParts;

        employeeCriteria: any = { showEmployeesOnly: true, includeSharedEmployee: true }
        serviceCriteria: any;
        employeeHasChanged: boolean = false;
        resourceHasChanged: boolean = false;

        canEditPermission = false;
        canAddPermission = false;
        isReadOnly: boolean = false;

        notesToggled: boolean = false;

        chromeVersion: any;
        returnStateInfo: any;
        payingClientCardsOnFile: any[];
        payingClientPaymentAccounts: any[];
        payingClientCardOnFileChanged = () => {
            if (this.currentAppointment.payingClient && this.currentAppointment.payingClient.id) {
                if (_([...this.currentAppointment.services, this.currentDetail]).any(appointmentService => {
                    return appointmentService.client && appointmentService.client.id === this.currentAppointment.payingClient.id;
                })) {
                    this.getClientCardOnFile(this.currentAppointment.payingClient.id);
                }
                this.getPayingClientCardOnFile(this.currentAppointment.payingClient);
            }
        }
        showPayingClientAlerts: boolean;
        payingClientHasSpecificAlert: boolean;
        showServicingClientAlerts: boolean;
        servicingClientHasSpecificAlert: boolean;
        optInClientSelectionAfterActions: boolean = true;

        constructor(
            private restServer: any,
            private $appointmentBookModal: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            private helper: any,
            private actions: any,
            private $rootScope: any,
            private $translate: angular.translate.ITranslateService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private securityChecker: Meevo.Components.Common.ISecurityService,
            private $mdToast: angular.material.IToastService,
            private globals,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private $q: angular.IQService,
            private modalService: Meevo.Components.Modal.IModalService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private $timeout: angular.ITimeoutService,
            private recentService: Meevo.Components.Common.RecentService,
            private roundingService: Meevo.Components.Common.RoundingService,
            protected stepOverrideService: Meevo.Plugins.AppointmentBook.StepOverride,
            private appointmentNoteService: Meevo.Plugins.AppointmentBook.AppointmentNoteService,
            protected $state: any,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            private membershipDetailsService: Meevo.Components.Common.MembershipDetailsService,
            private $compile: angular.ICompileService,
            private referralService: Meevo.Plugins.Referral.ReferralService,
            private meevoNoteService: Meevo.Plugins.Note.NoteService
        ) {

            const service = this;
            this.chromeVersion = this.getChromeVersion();
            this.refreshServiceCriteria();

            this.$rootScope.$on("bookPendingAppointment", (event, args) => {
                service.isReadOnly = false;
                service.actions.bookPendingAppointment(args);
                this.bindHotkeys();
            });

            this.$rootScope.$on("newAppointment", (event, args) => {
                service.isReadOnly = false;
                this.newAppointment(args, null);
                this.bindHotkeys();
            });

            this.$rootScope.$on("openAppointment", (event, args) => {
                service.openAppointment(args.id, args.appointmentServiceId, args.isReadOnly, args.returnStateInfo);
            });

            this.securityChecker.checkSecurityKey(this.securityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEW_ADDONS).then(result => {
                this.serviceAddOnPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
            this.securityChecker.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.clientReadPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
            this.securityChecker.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE).then(result => {
                this.clientWritePermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITAPPOINTMENT).then(result => {
                this.canEditPermission = (result === Model.SecurityAccessEnum.Grant);
            });
            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT).then(result => {
                this.canAddPermission = (result === Model.SecurityAccessEnum.Grant);
            });
            this.securityChecker.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_CREDITCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.clientCreditCardReadPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });

            this.$rootScope.$watch(() => this.currentDetail && this.currentDetail.client, (newVal, oldVal) => {
                if (this.isFromWaitList) {
                    return;
                }

                // field was cleared out.  servicingClientChanged won't be call so need to hide here
                if (!newVal) {
                    this.hideServicingClientAlerts();
                }
                if (!this.currentDetail) {
                    return;
                }

                // fix clientType if we're changing to a real client
                const isNewClient = newVal && newVal.id;
                if (isNewClient) {
                    this.currentDetail.clientType = ClientTypeEnum.Client;
                }

                if (this.currentDetail.clientType !== ClientTypeEnum.Client) {
                    return;
                }

                if (this.currentDetail.ignoreServicingClientChange) {
                    this.currentDetail.ignoreServicingClientChange = undefined;
                    return;
                }

                if (!newVal) {
                    if (this.currentDetail.isAddNewClient) {
                        this.servicingClientChanged('Client', this.currentDetail.isAddNewClient);
                        this.currentDetail.isAddNewClient = undefined;
                        return;
                    }
                    return;
                }

                if (!oldVal || newVal.id != oldVal.id) {
                    this.depositPrompt()
                        .then(() => {
                            this.servicingClientChanged('Client');
                        })
                        .catch(() => {
                            this.currentDetail.ignoreServicingClientChange = true;
                            this.currentDetail.client = oldVal;
                        });
                }
            }, true);

            this.$rootScope.$watch(() => this.currentDetail && this.currentDetail.clientType, (newVal, oldVal) => {
                if (!this.currentDetail) {
                    return;
                }

                if (this.currentDetail.clientType === ClientTypeEnum.Client) {
                    return;
                }

                if (this.currentDetail.ignoreServicingClientChange) {
                    this.currentDetail.ignoreServicingClientChange = undefined;
                    return;
                }

                if (!newVal) {
                    if (this.currentDetail.isAddNewClient) {
                        this.currentDetail.isAddNewClient = undefined;
                        this.servicingClientChanged('ClientType');
                        return;
                    }
                    return;
                }

                if (newVal != oldVal) {
                    this.depositPrompt()
                        .then(() => {
                            this.servicingClientChanged('ClientType');
                        })
                        .catch(() => {
                            this.currentDetail.ignoreServicingClientChange = true;
                            this.currentDetail.clientType = oldVal;
                        });
                }
            });
        }

        private openAppointment(id, appointmentServiceId?, isReadOnly?, returnStateInfo?) {
            this.appointmentNoteService.setNoteTypes();
            this.bindHotkeys();
            this.employeeHasChanged = false;
            this.resourceHasChanged = false;
            this.currentDetail = undefined;
            this.currentAppointment = undefined;
            this.serviceAlerts = [];
            this.clientAlerts = [];
            this.payingClientAlerts = [];
            this.payingClientMembershipAlerts = [];
            this.clientMembershipAlerts = [];
            this.payingClientPointsAlerts = [];
            this.clientPointsAlerts = [];
            this.clientGiftCardAlerts = [];
            this.payingClientGiftCardAlerts = [];
            this.clientNotes = [];
            this.payingClientNotes = [];
            this.allAggregatedNotes = {};
            this.isReadOnly = isReadOnly;
            this.returnStateInfo = returnStateInfo;
            this.isFromStanding = false;
            this.hidePayingClientAlerts();
            this.hideServicingClientAlerts();
            $(`div[name=${this.amPmIdentifier}]`).removeClass('am-pm-pulse');
            window.focus();
            return this.restServer.getAppointment(id, true, isReadOnly, true).then((result) => {

                this.isInEdit = true;
                this.hasClientId = result.data.payingClientId !== undefined;
                    var needToUpdateResource = false;
                    for (var i = 0; i < result.data.services.length; i++) {
                        var appointmentService = result.data.services[i];

                    appointmentService.startTime = appointmentService.startDateTime;
                    appointmentService.startDate = moment(appointmentService.startDateTime).startOf('day').toDate();

                    appointmentService.stateEnum = Meevo.Model.StateEnum.Read;
                    appointmentService.client = {
                        id: appointmentService.clientId,
                        firstName: appointmentService.clientFirstName,
                        lastName: appointmentService.clientLastName,
                        displayName: appointmentService.clientDisplayName,
                        primaryPhoneNumber: appointmentService.clientPhoneNumber,
                        primaryPhoneNumberCountryCode: appointmentService.clientCountryCode,
                        isRestricted: appointmentService.clientIsRestricted,
                        gender: appointmentService.clientGender
                    }
                    this.setService(appointmentService, appointmentService.serviceId, appointmentService.serviceShortcut, appointmentService.serviceDisplayName, appointmentService.serviceDescription, appointmentService.isAddressRequired, appointmentService.serviceCategoryId);

                    if (!appointmentService.employee) {
                        this.setEmployee(appointmentService, appointmentService.steps[0].employeeId, appointmentService.steps[0].employeeDisplayName);
                    }

                    appointmentService.originalEmployeeId = appointmentService.steps[0].employeeId;
                    appointmentService.originalResourceId = appointmentService.resource ? appointmentService.resource.id : undefined;

                    if (appointmentService.appointTypeItemId != undefined) {
                        appointmentService.appointType = {
                            id: appointmentService.appointTypeItemId,
                            displayName: appointmentService.appointTypeDisplayName,
                            shortcut: appointmentService.appointTypeShortcut
                        }
                    }
                    if (!appointmentService.clientId && appointmentService.clientType != ClientTypeEnum.Client) {
                        appointmentService.client = {
                            id: undefined,
                            clientType: appointmentService.clientType,
                            displayName: this.$translate.instant(appointmentService.clientDisplayName)
                        }
                    }

                    if (this.genderPreferences != undefined) {
                        appointmentService.genderPreference = _.where(this.genderPreferences, { id: appointmentService.genderPreference })[0];
                    }

                    appointmentService.steps.forEach((appointDetailStep) => {
                        appointDetailStep.stateEnum = Meevo.Model.StateEnum.Read;
                    });

                    this.calculateStepDuration(appointmentService);

                    this.loadServiceCheckboxes(appointmentService);

                    if (appointmentService.clientType === Meevo.Model.ClientTypeEnum.Client ||
                        appointmentService.clientType === Meevo.Model.ClientTypeEnum.Employee ||
                        appointmentService.clientType === Meevo.Model.ClientTypeEnum.Transient) {
                        appointmentService.hasClientId = true;
                        appointmentService.isInEdit = true;
                    } else {
                        appointmentService.hasClientId = false;
                        appointmentService.isInEdit = true;
                    }

                    // check if the service requires a resource and if that resource is no longer active, if yes, it will need to be reassigned
                    if (appointmentService.resource != undefined && appointmentService.resource.objectState !== Meevo.Model.ObjectStateEnum.Active && !isReadOnly) {
                        needToUpdateResource = true;
                    }

                        this.setOriginalAddress(appointmentService);
                        this.recentService.addRecent(appointmentService.client, Meevo.Components.Common.Constants.RECENT_KEY_CLIENT, true);

                }
                this.checkForClientMissingFieldAlert(result.data.services[0].clientId, this.clientAlerts, true);
                this.getClientCardOnFile(result.data.services[0].clientId);

                result.data.payingClient = {
                    firstName: result.data.payingClientFirstName,
                    lastName: result.data.payingClientLastName,
                    id: result.data.payingClientId,
                    displayName: result.data.payingClientDisplayName,
                    primaryPhoneNumber: result.data.payingClientPhoneNumber,
                    primaryPhoneNumberCountryCode: result.data.payingClientCountryCode,
                    clientTypeId: result.data.payingClient && result.data.payingClient.clientTypes && result.data.payingClient.clientTypes.length ? result.data.payingClient.clientTypes[0].id : undefined,
                    isRestricted: result.data.payingClientIsRestricted
                };

                this.checkForClientMissingFieldAlert(result.data.payingClientId, this.payingClientAlerts);
                this.getPayingClientCardOnFile(result.data.payingClient);

                if (!result.data.payingClientId && result.data.payingClientType != ClientTypeEnum.Client) {
                    result.data.payingClient = {
                        id: undefined,
                        clientType: result.data.payingClientType,
                        displayName: this.$translate.instant(result.data.payingClientDisplayName)
                    }
                }

                if (result.data.appointmentCategoryId != undefined) {
                    result.data.appointCat = {
                        id: result.data.appointmentCategoryId,
                        displayName: result.data.appointmentCategoryDisplayName
                    };
                }

                if (result.data.noteType != undefined && result.data.noteType !== 0) {
                    this.local.noteType = _.where(this.appointmentNoteService.noteTypes, { id: result.data.noteType })[0];
                } else {
                    this.local.noteType = _.where(this.appointmentNoteService.noteTypes, { id: Meevo.Model.AppointNoteTypeEnum.AppointmentBookOnly })[0];
                }

                result.data.isLocal = result.data.locationId == this.identityService.effectiveLocationId;

                this.currentAppointment = result.data;
                this.originalAppointment = angular.copy(this.currentAppointment); //save to compare later
                this.selectAppointDetail(appointmentServiceId);
                this.getPayingClientNotes(this.currentAppointment.payingClient);

                if (needToUpdateResource) {
                    this.updateResources(this.currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: true });
                }

                this.getClientMembershipInfo();

                if (this.globals.businessInfo.enableIntegratedRegister) {
                    const appointmentServices = result.data.services;

                    this.calculateAppointmentServicePrice(appointmentServices);
                } else {
                    result.data.services.forEach(
                        appointmentService => appointmentService.totalPrice = this.calculatePrice(appointmentService));
                }

                $('#appointmentEditorForm #editor_maximized').show();
            });
        }

        private calculateAppointmentServicePrice(appointmentServices) {
            let serviceAddOns = appointmentServices
                .filter(appointmentService => appointmentService.serviceAddOns)
                .map(appointmentService => 
                    appointmentService.serviceAddOns.map(addOn => {
                        addOn.clientId = appointmentService.clientId;
                        addOn.employeeId = appointmentService.employeeId;
                        addOn.startDateTime = appointmentService.startDateTime;
                        addOn.appointmentServiceId = appointmentService.id;
                        addOn.isNew = appointmentService.isNew;
                        return addOn;
                    })
                );

            serviceAddOns = _(serviceAddOns).flatten(true);

            let servicePriceRequests = appointmentServices
                .map(appointmentService => ({
                    serviceId: appointmentService.serviceId,
                    employeeId: appointmentService.employeeId,
                    clientId: appointmentService.clientId,
                    startDateTime: appointmentService.startDateTime,
                    appointmentServiceId: appointmentService.isNew ? null : appointmentService.id,
                }));

            let serviceAddOnPriceRequests = serviceAddOns
                .map(addOn => ({
                    serviceId: addOn.addOnServiceId,
                    employeeId: addOn.employeeId,
                    clientId: addOn.clientId,
                    startDateTime: addOn.startDateTime,
                    appointmentServiceId: addOn.isNew ? null : addOn.appointmentServiceId,
                }));

            // remove dupes in case an appointmentService has the same client/employee/serviceId as an addOn
            servicePriceRequests = _(servicePriceRequests.concat(serviceAddOnPriceRequests)).chain().uniq().value();

            this.restServer.getRegisterPriceList(servicePriceRequests, true).then((response) => {
                response.data.services.forEach(priceResponse => {
                    const matchingServices = appointmentServices.filter(appointmentService =>
                        appointmentService.serviceId == priceResponse.priceRequest.serviceId &&
                        appointmentService.employeeId == priceResponse.priceRequest.employeeId &&
                        appointmentService.clientId == priceResponse.priceRequest.clientId &&
                        moment(appointmentService.startDateTime).isSame(priceResponse.priceRequest.startDateTime) &&
                        (appointmentService.isNew || appointmentService.id == priceResponse.priceRequest.appointmentServiceId)
                    );
                    const matchingAddOns = serviceAddOns.filter(addOn =>
                        addOn.addOnServiceId == priceResponse.priceRequest.serviceId &&
                        addOn.employeeId == priceResponse.priceRequest.employeeId &&
                        addOn.clientId == priceResponse.priceRequest.clientId &&
                        moment(addOn.startDateTime).isSame(priceResponse.priceRequest.startDateTime) &&
                        (addOn.isNew || addOn.appointmentServiceId == priceResponse.priceRequest.appointmentServiceId)
                    );

                    matchingServices.forEach(appointmentService => appointmentService.price = priceResponse.finalPriceCharge);
                    matchingAddOns.forEach(addOn => addOn.price = priceResponse.finalPriceCharge);
                });
                appointmentServices.forEach(appointmentService => appointmentService.totalPrice = this.calculatePrice(appointmentService));
            });
        }

        private hidePayingClientAlerts() {
            this.showPayingClientAlerts = false;
            this.payingClientHasSpecificAlert = false;
        }

        public hasPayingClientAlert(isGeneralAlert: boolean = false) {
            if (!isGeneralAlert) {
                this.payingClientHasSpecificAlert = true;
            }
            this.showPayingClientAlerts = true;
        }

        public hideServicingClientAlerts() {
            this.showServicingClientAlerts = false;
            this.servicingClientHasSpecificAlert = false;
        }

        public hasServicingClientAlert(isGeneralAlert: boolean = false) {
            if (!isGeneralAlert) {
                this.servicingClientHasSpecificAlert = true;
            }
            this.showServicingClientAlerts = true;
        }

        private anyServicingClientHasDeposit(): boolean {
            if (this.currentAppointment.services.length === 0) {
                return !!this.currentDetail.clientType.depositAmount;
            }

            return _(this.currentAppointment.services).any(appointmentService => !!appointmentService.depositAmount);
        }

        private getDistinctServicingClient() {
            if (this.currentAppointment.services.length === 0) {
                return {
                    clientType: this.currentDetail.clientType,
                    clientId: this.currentDetail.client ? this.currentDetail.client.id : null,
                    displayName: this.currentDetail.client ? this.currentDetail.client.displayName : this.getAnonymousClientName(this.currentDetail.clientType),
                }
            }

            const distinctServicingClients = _.chain(this.currentAppointment.services)
                .map(appointmentService => [
                    appointmentService.clientType,
                    appointmentService.client ? appointmentService.client.id : null,
                    appointmentService.client ? appointmentService.client.displayName : this.getAnonymousClientName(appointmentService.clientType),
                ])
                .uniq(false, (item) => `${item[0]}${item[1]}`)
                .value();

            if (distinctServicingClients.length !== 1) {
                return null;
            }

            return {
                clientType: distinctServicingClients[0][0],
                clientId: distinctServicingClients[0][1],
                displayName: distinctServicingClients[0][2],
            };
        }

        private depositPrompt() {
            let deferred = this.$q.defer();

            if (this.currentDetail.suppressDepositPrompt) {
                this.currentDetail.suppressDepositPrompt = false;
                deferred.resolve();
                return deferred.promise;
            }

            if (!this.currentDetail.depositAmount) {
                deferred.resolve();
                return deferred.promise;
            }

            const message = this.$translate.instant("MESSAGE_HAS_DEPOSIT_CLIENT", {
                serviceName: `${this.currentDetail.service.shortcut}: ${this.currentDetail.service.displayName}`,
                clientName: this.currentDetail.clientDisplayName,
            });

            this.$appointmentBookModal.showMessage(message, {
                buttonsType: Meevo.Model.ButtonTypeEnum.OkCancel,
                callback: (result) => {
                    if (result === Meevo.Model.MessageBoxButtonResult.Ok) {
                        this.currentDetail.depositAmount = null;
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }
                }
            });

            return deferred.promise;
        }

        newAppointment(args, callbackFunc) {
            this.updateEmployeeCriteria();
            this.appointmentNoteService.setNoteTypes();
            this.currentDetail = undefined;
            this.currentAppointment = undefined;
            this.serviceAlerts = [];
            this.clientAlerts = [];
            this.payingClientAlerts = [];
            this.payingClientMembershipAlerts = [];
            this.clientMembershipAlerts = [];
            this.payingClientPointsAlerts = [];
            this.clientPointsAlerts = [];
            this.clientGiftCardAlerts = [];
            this.payingClientGiftCardAlerts = [];
            this.clientNotes = [];
            this.payingClientNotes = [];
            this.allAggregatedNotes = {};
            this.local.noteType = _.where(this.appointmentNoteService.noteTypes, { id: -1 })[0];
            this.isInEdit = false;
            this.hasClientId = true;
            this.createNewAppointment(moment(args.date, "M-D-YYYY"), moment(args.startTime, "h:m"));
            this.currentDetail.employee = args.employee;
            this.currentDetail.resource = args.resource;
            this.refreshServiceCriteria();
            this.employeeHasChanged = !!args.employee;
            this.resourceHasChanged = !!args.resource;
            this.resourceChanged();
            this.isFromStanding = args.isFromStanding;
            this.hidePayingClientAlerts();
            this.hideServicingClientAlerts();
            this.optInClientSelectionAfterActions = _.isUndefined(args.optInClientSelectionAfterActions) || args.optInClientSelectionAfterActions;

            if (args.isFromWaitList || args.isFromRebook || args.isFromStanding) {
                this.bookFromWaitList(args, callbackFunc);
            }

            $('#appointmentEditorForm #editor_maximized').show();
        }

        getClientMembershipInfo(clientIds: Guid[] = undefined) {
            if (!clientIds) {
                clientIds = new Array();
                if (this.currentAppointment.payingClient != undefined) {
                    clientIds.push(this.currentAppointment.payingClient.id);
                }
                if (this.currentDetail.client != undefined && clientIds.indexOf(this.currentDetail.client.id) < 0) {
                    clientIds.push(this.currentDetail.client.id);
                }
            }
            if (clientIds && clientIds.length > 0) {
                this.restServer.LoadMembershipDetails(clientIds).then(res => {
                    res.data.forEach((membership) => {
                        if (this.currentAppointment.payingClientType === ClientTypeEnum.Client && membership.clientId == this.currentAppointment.payingClient.id) {
                            this.currentAppointment.payingClient.membershipId = membership.id;
                            this.currentAppointment.payingClient.clientMembershipId = membership.clientMembershipId;
                            this.currentAppointment.payingClient.membershipIndicatorStatus = membership.clientMembershipIndicatorStatusEnum;
                            this.currentAppointment.payingClient.membershipStatus = membership.clientMembershipStatusEnum;
                            this.currentAppointment.payingClient.membershipDisplayName = membership.membershipDisplayName;
                        }

                        if (this.currentDetail.clientType == ClientTypeEnum.Client && membership.clientId == this.currentDetail.client.id) {
                            this.currentDetail.client.membershipId = membership.id;
                            this.currentDetail.client.clientMembershipId = membership.clientMembershipId;
                            this.currentDetail.client.membershipIndicatorStatus = membership.clientMembershipIndicatorStatusEnum;
                            this.currentDetail.client.membershipStatus = membership.clientMembershipStatusEnum;
                            this.currentDetail.client.membershipDisplayName = membership.membershipDisplayName;
                        }
                    });
                });
            }
        }

        refreshServiceCriteria() {
            this.serviceCriteria = { isBookable: true, wildCardType: Model.FilterWildcardType.Contains };
            if (this.currentAppointment.appointmentDate) {
                this.serviceCriteria.bookDateTime = this.getDateTime(this.currentDetail);
            }

            if (!this.currentDetail || !this.globals.onlyShowServicesPerformedByEmployeeAndResource) {
                return;
            }

            if (this.currentDetail.employee && this.currentDetail.employee.id) {
                this.serviceCriteria.employeeId = this.currentDetail.employee.id;
            } else {
                this.serviceCriteria.employeeId = undefined;
            }

            if (this.currentDetail.resource && this.currentDetail.resource.id) {
                this.serviceCriteria.resourceId = this.currentDetail.resource.id;
            } else {
                this.serviceCriteria.resourceId = undefined;
            }
        }

        setEmployee(appointDetail, employeeId, employeeDisplayName, raiseChanged: any = undefined) {
            if (employeeId) {
                appointDetail.employee = {
                    id: employeeId,
                    displayName: employeeDisplayName
                }
            }

            if (raiseChanged) {
                this.employeeChanged();
            }
        }

        setService(appointDetail, serviceId, serviceShortcut, serviceDisplayName, serviceDescription, isAddressRequired, serviceCategoryId, raiseChanged: any = undefined) {
            appointDetail.service = {
                id: serviceId,
                shortcut: serviceShortcut,
                displayName: serviceDisplayName,
                description: serviceDescription,
                isAddressRequired: isAddressRequired,
                serviceCategoryId: serviceCategoryId
            }
            appointDetail.serviceShortcut = serviceShortcut;

            if (raiseChanged) {
                this.serviceChanged();
            }
        }

        loadServiceCheckboxes(appointmentService) {
            appointmentService.isRequested = (appointmentService.employeeType === Meevo.Model.EmployeeTypeEnum.Request);
            appointmentService.isRedo = (appointmentService.reBookingType === Meevo.Model.ReBookingTypeEnum.Redo);
            appointmentService.isWalkin = (appointmentService.bookingType === Meevo.Model.BookingTypeEnum.Walkin);
        }

        saveServiceCheckboxes(appointmentService) {
            appointmentService.employeeType = appointmentService.isRequested === true
                ? Meevo.Model.EmployeeTypeEnum.Request
                : Meevo.Model.EmployeeTypeEnum.NonRequest;

            if (appointmentService.isRedo === true) {
                appointmentService.reBookingType = Meevo.Model.ReBookingTypeEnum.Redo;
            }
            else if (!appointmentService.reBookingType || appointmentService.reBookingType === Meevo.Model.ReBookingTypeEnum.Redo) {
                appointmentService.reBookingType = Meevo.Model.ReBookingTypeEnum.Normal;
            }

            appointmentService.bookingType =  appointmentService.isWalkin === true
                ? Meevo.Model.BookingTypeEnum.Walkin
                : Meevo.Model.BookingTypeEnum.Booked;
        }

        private bookFromWaitList(args, callbackFunc) {
            this.isFromWaitList = true;
            this.pendingAppointmentIdToDelete = args.appointmentId;
            this.pendingIdToDelete = args.id;
            var services = [];

            this.dataService.customMethodData(`/api/appointmentservice/templatelist`,
                "post",
                {
                    employeeServiceClientIds: _(args.services).map(service => {
                        return {
                            serviceId: service.service.id,
                            employeeId: service.employee.id,
                            clientId: args.payingClient.id
                        }
                    }),
                }).then((result) => {

                    $.each(result.data, (index: number, service) => {
                        services.push(service);

                        this.createNewAppointDetail(moment(args.services[index].startTime, "h:m"), args.services[index].employee, undefined, args.payingClient);
                        service.displayName = service.serviceDisplayName;
                        service.shortcut = service.serviceShortcut;
                        this.currentDetail.service = service;
                        this.currentDetail.service.id = args.services[index].serviceId;
                        if (args.services[index].steps) {
                            args.services[index].steps.forEach(step => {
                                let templateStep = _(service.steps).findWhere({ serviceStepId: step.serviceStepId });
                                if (templateStep) {
                                    templateStep.durationInMinutes = step.durationInMinutes;
                                    templateStep.extendedByStepMinutes = step.extendedByStepMinutes;
                                    templateStep.durationWithAddOnsInMinutes = step.durationWithAddOnsInMinutes;
                                }
                            });
                        }
                        this.currentDetail.steps = services[index].steps;
                        this.currentDetail.startDateTime = args.services[index].startDateTime;
                        this.currentDetail.startTime = args.services[index].startTime;
                        this.currentDetail.bookingMethod = args.isFromWaitList ? Meevo.Model.BookingMethodEnum.WaitListManual : Meevo.Model.BookingMethodEnum.FrontDesk;
                        this.currentDetail.finalState = Meevo.Model.AppointFinalStateEnum.None;
                        this.currentDetail.transitionState = Meevo.Model.AppointStateEnum.Booked;
                        this.currentDetail.resourceId = args.services[index].resourceId;
                        this.currentDetail.resourceUnitId = args.services[index].resourceUnitId;
                        this.currentDetail.genderPreference = args.services[index].genderPreference;
                        this.currentDetail.nonRequest = args.services[index].nonRequest;
                        this.currentDetail.isRequested = !args.services[index].nonRequest;
                        this.currentDetail.appointmentServiceScheduleId = args.services[index].appointmentServiceScheduleId;
                        this.currentDetail.serviceAddOns = args.services[index].serviceAddOns;
                        this.calculateStepDuration(this.currentDetail);
                        this.currentAppointment.appointmentDate = args.services[index].startDateTime;//args.startTime;//
                        this.currentAppointment.payingClient = args.payingClient;
                        this.currentAppointment.services.push(this.currentDetail);
                        this.currentAppointment.note = args.note;
                        this.currentAppointment.appointCat = args.appointmentCategory;

                        if (index === result.data.length - 1) {
                            return this.saveAppointment(null, callbackFunc);
                        }
                    });
                });

        }

        private createNewAppointment(date, startTime) {
            this.currentAppointment = {
                appointCat: undefined,
                payingClient: undefined,
                services: [],
                note: undefined,
                payingClientType: Meevo.Model.ClientTypeEnum.Client,
                confirmState: Meevo.Model.ConfirmStateEnum.Unconfirmed,
                isLocal: true
            };
            this.currentAppointment.appointmentDate = date.toDate();
            this.createNewAppointDetail(startTime);
        }

        private createNewAppointDetail(startTime, employee: any = undefined, appointType: any = undefined, client: any = undefined, service: any = undefined, hasServiceAddOn: boolean = false) {
            this.currentDetail = {
                stateEnum: Meevo.Model.StateEnum.Add,
                steps: [],
                id: NewGuid(),
                genderPreference: null,
                isNew: true,
                client: client,
                employee: employee,
                appointType: appointType,
                startTimeSegmented: {
                    value: new Date(Date.now())
                },
                isWalkin: false,
                isRedo: false,
                isRequested: this.setIsRequested(),
                clientType: (client ? client.clientType : undefined) || Meevo.Model.ClientTypeEnum.Client,
                isInEdit: false,
                hasClientId: false,
                resource: null,
                hasServiceAddOn: hasServiceAddOn,
                addOnCount: 0,
                serviceAddOns: [],
                service: service,
                preventNotifications: this.currentDetail && this.currentDetail.client && client && this.currentDetail.client.id === client.id 
                    ? this.currentDetail.preventNotifications 
                    : false
            };

            if (this.genderPreferences != undefined) {
                this.currentDetail.genderPreference = _.where(this.genderPreferences, { id: this.currentDetail.genderPreference })[0];
            }

            if (startTime != undefined) {
                this.currentDetail.startTimeSegmented.value.setHours(startTime.format("HH"));
                this.currentDetail.startTimeSegmented.value.setMinutes(startTime.format("mm"));
            }
            this.currentDetail.startTime = startTime.format();
        }

        setIsRequested() {
            return (this.IsRequestedEmployeeSelectionRequired() ? undefined : (this.globals.requestedAppointmentDefaultFlag === Meevo.Model.AppointmentBookRequestNonRequestSelectionEnum.RequestedByDefault));
        }
        IsRequestedEmployeeSelectionRequired() {
            return this.globals.requestedAppointmentDefaultFlag === Meevo.Model.AppointmentBookRequestNonRequestSelectionEnum.RequireSelectionRequestNotRequest;
        }

        hasClientIdshow() {
            if (this.currentDetail.isInEdit === false) {
                return true;
            } else {
                return this.currentDetail.hasClientId;
            }
        }

        hasAnonClientIdshow() {
            if (this.currentDetail.isInEdit === false) {
                return true;
            } else {
                return !this.currentDetail.hasClientId;
            }
        }

        hasPayingClientIdshow() {
            if (this.isInEdit === false) {
                return true;
            } else {
                return this.hasClientId;
            }
        }

        hasPayingAnonClientIdshow() {
            if (this.isInEdit === false) {
                return true;
            } else {
                return !this.hasClientId;
            }
        }

        addNewServiceOrClient(isClient: boolean = false) {
            this.saveAppointDetail(null, isClient);
            if (isClient) {
                this.currentDetail.isAddNewClient = true;
            }
        }

        saveAppointDetail(useClient?: Model.ClientListItem, addNewClient = false) {
            this.assertCanSaveAppointmentDetail();

            if (this.validateAppointmentService(this.currentDetail)) {
                const currentClient = (useClient) ? useClient : this.currentDetail.client;
                const currentService = this.currentDetail.service;
                const currentClientServices = this.getClientServices(this.currentAppointment.services, currentClient);

                // used to hold either the currentDetail or the last service for a given client
                let servicePointOfReference = this.getServicePointOfReference(currentClientServices, addNewClient);

                let newService = null;
                let newTime = null;

                if (addNewClient) {
                    newService = this.currentAppointment.services[0];

                    if (!newService.startTimeSegmented) {
                        newService.startTimeSegmented = this.getStartTimeSegmented(moment(newService.startTime));
                    }

                    newTime = this.getMoment(newService.startTimeSegmented);
                }
                else {
                    newService = servicePointOfReference;
                    newService.preventNotifications = currentClientServices[0].preventNotifications;
                    let finalStep = _(newService.steps).last();
                    let minutesToAdd = newService.durationWithAddOnsInMinutes - (finalStep.isCleanupStep ?
                        finalStep.durationWithAddOnsInMinutes :
                        0);
                    newTime = this.getMoment(newService.startTimeSegmented).add(minutesToAdd, "minutes");
                    let incrementNumber = this.helper.convertAppointmentBookIncrementToNumber(this.globals.businessInfo.appointmentBookPrecisionIncrement)
                    let invalidMinutes = newTime.totalMinutes() % incrementNumber;
                    if (invalidMinutes > 0) {
                        newTime.add("m", incrementNumber - invalidMinutes);
                    }
                }

                const isNotAdded = _.where(this.currentAppointment.services, { id: servicePointOfReference.id }).length === 0;

                if (isNotAdded) {
                    this.currentAppointment.services.push(servicePointOfReference);
                }

                this.createNewAppointDetail(
                    newTime,
                    addNewClient ? undefined : this.currentDetail.employee,
                    servicePointOfReference.appointType,
                    addNewClient ? undefined : currentClient,
                    addNewClient ? currentService : undefined,
                    addNewClient ? this.currentDetail.hasServiceAddOn : false
                );

                this.setCurrentDetailClient(currentClient, isNotAdded);
                this.setSaveAppointDetailFocus(addNewClient);
            }

            this.updateRequestedState();
        }

        private getClientServices(allServices: Model.AppointmentService[], client: any) {
            return _.filter(allServices, (item: Model.AppointmentService) => {
                const clientId = item.client ? item.client.id : item.clientId;

                return client.id
                    ? clientId == client.id
                    : item.clientType == client.clientType;
            });
        }

        private assertCanSaveAppointmentDetail(useClient?: Model.ClientListItem, addNewClient = false): boolean {
            if (!this.canEdit()) {
                return false;
            }

            if (!isObject(this.currentAppointment.payingClient)) {
                this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_PAYING_CLIENT_REQUIRED_PROCEED"));

                return false;
            }
        }
        private getServicePointOfReference(currentClientServices: Model.AppointmentService[], addNewClient: boolean): any {
            let servicePointOfReference: any;

            if (currentClientServices.length > 0) {
                // we need to get the last service for that client to add the new service at the correct time with the right employee
                servicePointOfReference = _.last(currentClientServices);

                const startTime = moment(servicePointOfReference.startTime);

                servicePointOfReference.startTimeSegmented = this.getStartTimeSegmented(startTime);
            }
            else {
                servicePointOfReference = this.currentDetail;
            }

            return servicePointOfReference;
        }
        private getStartTimeSegmented(startTime: any): any {
            return {
                value: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate(),
                    Number(startTime.format("HH")),
                    Number(startTime.format("mm")))
            }
        }
        private getMoment(time: any): any {
            return moment(time.value.getHours() + ":" + time.value.getMinutes(), "h:m a");
        }
        private setCurrentDetailClient(currentClient: any, isNotAdded: boolean): void {
            if (currentClient != undefined && isNotAdded) {
                // use this.currentDetail here because createNewAppointDetail will have set this.currentDetail with the newly created appointment service.
                this.currentDetail.client = {
                    id: currentClient.id,
                    firstName: currentClient.firstName,
                    lastName: currentClient.lastName
                };
            }
        }
        private setSaveAppointDetailFocus(addNewClient: any): void {
            if (addNewClient) {
                $("#currentDetailServiceClient input").focus(100);
            }
            else {
                $("#currentDetailService input").focus(100);
            }
        }

        private appointDetailBeingDeleted;

        removeAppointDetail(appointmentService, event) {
            event.stopPropagation();

            if (appointmentService.isNew) {
                this.appointDetailBeingDeleted = appointmentService;
                return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_DELETE_CONFIRMATION"), {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback: this.deleteAppointDetailConfirmation,
                    callbackParam: this
                });
            } else {
                let user = this.identityService.current();
                let meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
                this.securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEAPPOINTMENT)
                    .then(result => {
                        if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                            return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NOT_IN_SECURITY_ROLE"));
                        }

                        this.securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEANYAPPOINTMENT).then(result => {
                            if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                                continueExecution(true);
                                return;
                            }

                            let isDeleteAllowed = _.some(this.currentAppointment.services, (appointmentService: any) => {
                                return user.userId === appointmentService.employeeId;
                            });

                            if (!isDeleteAllowed) {
                                return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NOT_IN_DELETE_ANY_APPOINTMENT_SECURITY_ROLE"));
                            }

                            continueExecution(false);
                        });
                    });

                let continueExecution = (deleteAnyPermission: boolean) => {
                    if (!appointmentService.depositAmount) {
                        finishExecution(deleteAnyPermission);
                        return;
                    }

                    const message = this.$translate.instant("MESSAGE_HAS_DEPOSIT_SERVICE", {
                        serviceName: `${this.currentDetail.service.shortcut}: ${this.currentDetail.service.displayName}`,
                    });

                    this.$appointmentBookModal.showMessage(message).finally(() => {
                        finishExecution(deleteAnyPermission);
                    });
                }

                let finishExecution = (deleteAnyPermission: boolean) => {
                    let filteredAppointment = this.currentAppointment;

                    if (!deleteAnyPermission) {
                        filteredAppointment = angular.copy(this.currentAppointment);
                        filteredAppointment.services = filteredAppointment.services.filter((appointmentService) => user.userId === appointmentService.employeeId);
                    }

                    let appointmentServiceIdsToDelete = [];
                    if (!appointmentService.isNew && (deleteAnyPermission || user.userId === appointmentService.employeeId)) {
                        appointmentServiceIdsToDelete.push(appointmentService.id);
                    }

                    return this.actions.deleteAppointmentFromHeader(filteredAppointment, this.originalAppointment, appointmentServiceIdsToDelete, false).then(() => {
                        if (!deleteAnyPermission) {
                            filteredAppointment.services.forEach(service => {
                                const currentService = _.findWhere(this.currentAppointment.services, { id: service.id }) as any;
                                if (!currentService) {
                                    return;
                                }
                                // these should already exist on both sides
                                currentService.stateEnum = service.stateEnum;
                                currentService.finalState = service.finalState;
                                // this property may not exist, don't create it if not needed
                                if (service.cancellationReasonId) {
                                    currentService.cancellationReasonId = service.cancellationReasonId;
                                }
                            })
                        }

                        this.createNewAppointDetail(
                            moment(appointmentService.startTime),
                            appointmentService.employee,
                            appointmentService.appointType,
                            appointmentService.client);

                        this.helper.checkReturnToState(this, true);
                    });
                }
            }
        }

        deleteAppointment() {
            let user = this.identityService.current();

            let meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
            this.securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEAPPOINTMENT)
                .then(result => {
                    if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                        return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NOT_IN_SECURITY_ROLE"));
                    }

                    this.securityChecker.checkSecurityKey(meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_DELETEANYAPPOINTMENT)
                        .then(result => {
                            if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                                continueExecution(true);
                                return;
                            }

                            let isDeleteAllowed = _.some(this.currentAppointment.services, (appointmentService: any) => {
                                return user.userId === appointmentService.employeeId;
                            });

                            if (!isDeleteAllowed) {
                                return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NOT_IN_DELETE_ANY_APPOINTMENT_SECURITY_ROLE"));
                            }

                            continueExecution(false);
                        });
                });

            let continueExecution = (deleteAnyPermission: boolean) => {
                let filteredAppointment = this.currentAppointment;

                if (!deleteAnyPermission) {
                    filteredAppointment = angular.copy(this.currentAppointment);
                    filteredAppointment.services = filteredAppointment.services
                        .filter((appointmentService) => user.userId === appointmentService.employeeId);
                }

                let appointmentServiceIdsToDelete = [];
                filteredAppointment.services.forEach((appointmentService) => {
                    if (!appointmentService.isNew && (deleteAnyPermission || user.userId === appointmentService.employeeId)) {
                        appointmentServiceIdsToDelete.push(appointmentService.id);
                    }
                });

                this.actions.deleteAppointmentFromHeader(filteredAppointment, this.originalAppointment, appointmentServiceIdsToDelete, true).then((data) => {
                    if (data) {
                        this.unbindHotkeys();
                        this.helper.checkReturnToState(this, true);
                    }
                });
            }
        }

        deleteAppointDetailConfirmation = (response, parent) => {
            if (response === Meevo.Model.MessageBoxButtonResult.Yes) {

                parent.currentAppointment.services.splice(parent.currentAppointment.services.indexOf(parent.appointDetailBeingDeleted), 1);

                parent.createNewAppointDetail(moment(parent.appointDetailBeingDeleted.startTime), parent.appointDetailBeingDeleted.employee,
                    parent.appointDetailBeingDeleted.appointType, parent.appointDetailBeingDeleted.client);
            }
        }

        getTotalPrice(): number {
            let totalPrice = 0;

            if (this.currentAppointment && this.currentAppointment.services) {
                this.currentAppointment.services.forEach((appointmentService) => {
                    if (appointmentService.stateEnum !== Meevo.Model.StateEnum.Delete && appointmentService.transitionState !== Meevo.Model.AppointStateEnum.Pending) {
                        totalPrice += appointmentService.totalPrice || 0;
                    }
                });
            }
            return this.normalizeDecimalPlaces(totalPrice);
        }

        normalizeNumber(value: number): number {
            return this.roundingService.normalizeNumber(value);
        }

        normalizeDecimalPlaces(value: number): number {
            return this.roundingService.normalizeDecimalPlaces(value);
        }

        private calculatePrice(appointmentService): number {
            let totalPrice = appointmentService.price || 0;

            if (appointmentService.serviceAddOns) {
                appointmentService.serviceAddOns.forEach((serviceAddOn) => {
                    totalPrice += serviceAddOn.price || 0;
                });
            }

            return this.normalizeDecimalPlaces(totalPrice);
        }

        hasDeposit(service): boolean {
            return !!service.depositAmount;
        }

        calculateDeposit(service): number {
            return service.depositAmount;
        }

        // Note:  Went the override param route b/c there was a flicker on the required for the resource when clearing out elsewhere and reassigning
        // refreshResourcesIfNotEmpty is true when the service is not associated w/ selected resource
        // overrideExistingResource is true when the service is not associated w/ selected resource and the user responds that they do not wish to keep it
        updateResources(currentDetail, config: any = {}): ng.IPromise<boolean> {
            config.clearResource = "clearResource" in config ? config.clearResource : true;
            config.showUnavailableMessage = "showUnavailableMessage" in config ? config.showUnavailableMessage : true;

            var deferred: ng.IDeferred<boolean> = this.$q.defer();
            if (!currentDetail.resources || config.refreshResourcesIfNotEmpty) {
                if (currentDetail.isResourceRequired) {
                    for (let appointmentService of this.currentAppointment.services) {
                        appointmentService.payingClientId = this.currentAppointment.payingClient ? this.currentAppointment.payingClient.id : undefined;
                        appointmentService.clientId = appointmentService.client ? appointmentService.client.id : undefined;
                        appointmentService.employeeId = appointmentService.employee ? appointmentService.employee.id : undefined;
                    }

                    this.restServer.getAppointmentServiceResources(currentDetail, _.filter(this.currentAppointment.services, (service) => service != currentDetail), (response) => {
                        let isValid = true;
                        if (!currentDetail.resource || config.overrideExistingResource) {
                            if (_.where(response, { isAvailable: true }).length === 0) {
                                if (config.clearResource) {
                                    this.clearResource(currentDetail);
                                }
                                if (config.showUnavailableMessage) {
                                    isValid = false;
                                    this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NO_RESOURCES_AVAILABLE", {
                                        serviceDisplayName: currentDetail.service.displayName
                                    })).then(() => deferred.resolve(false));
                                }
                            } else {
                                // Ony select first available resource if no resource is currently select or the resource currently selected is no longer available.  Also,
                                // in the case where's there a resource assigned to the employee that's available, that should always be selected even if it means overriding the current selection
                                if (!currentDetail.resource || _.find(response, (resource: any) => {
                                    return resource.isServiceEmployeeScheduled && resource.isAvailable && currentDetail.resource.id != resource.id;
                                }) || !_.findWhere(response, { id: currentDetail.resource.id, isAvailable: true })) {
                                    this.syncResource(currentDetail, response);
                                    this.resourceHasChanged = true;
                                }
                                // Unit may be changed for the same resource on the server so always assign
                                var selectedResource: any = _.findWhere(response, { id: currentDetail.resource.id });
                                currentDetail.resourceUnitId = selectedResource.unitId;
                                currentDetail.resource.capacity = selectedResource.capacity;
                            }
                        }

                        if (response.length > 0 && response[0].isServiceEmployeeShared) {
                            this.clearEmployee(currentDetail);
                            isValid = false;
                            this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_SHARED_EMPLOYEE_RESOURCE", {
                                serviceDisplayName: currentDetail.service.displayName
                            })).then(() => deferred.resolve(false));
                        }
                        currentDetail.resources = response;
                        this.addBlankResource(currentDetail);
                        if (isValid) {
                            deferred.resolve(isValid);
                        }
                    });
                }
                else {
                    if (currentDetail.resource) {
                        currentDetail.resources = [];
                        if (config.overrideExistingResource) {
                            this.clearResource(currentDetail);
                        }
                        else {
                            // Add blank option so that they can unselect in the case where a resource isn't required, but the selected resource is a carryover from previous service selected
                            this.addBlankResource(currentDetail);
                        }
                    }
                    deferred.resolve(true);
                }
                return deferred.promise;
            }
        }

        syncResource(currentDetail, resources) {
            const clientId = currentDetail.client ? currentDetail.client.id : null;
            let resource = resources[0];
            // booking two services back to back for the same employee and same client, we want to try to keep same resource (available)
            var previousAppointmentService;
            for (let appointmentService of this.currentAppointment.services) {
                let appointmentServiceEndDateTime = this.getAppointmentServiceEndDateTime(appointmentService);
                if (appointmentService.client.id == clientId && appointmentService.employee && currentDetail.employee &&
                    appointmentService.employee.id == currentDetail.employee.id &&
                    appointmentServiceEndDateTime.isSame(currentDetail.startDateTime)) {
                    previousAppointmentService = appointmentService;
                    break;
                }
            }
            if (previousAppointmentService && previousAppointmentService.resource) {
                let resourceUsedInPreviousAppointmentService = _(resources).findWhere({ id: previousAppointmentService.resource.id, isAvailable: true });
                if (resourceUsedInPreviousAppointmentService &&
                    (resourceUsedInPreviousAppointmentService.schedules.length == 0 || resourceUsedInPreviousAppointmentService.isServiceEmployeeScheduled)) {
                    resource = resourceUsedInPreviousAppointmentService;
                }
            }
            currentDetail.resource = resource;
            currentDetail.resourceId = resource.id;
        }

        getAppointmentServiceEndDateTime(appointmentService) {
            return moment(appointmentService.startDateTime)
                .add(appointmentService.durationWithAddOnsInMinutes - this.getCleanupStepDuration(appointmentService), 'm');
        }

        openResourceSharingAssistant(appointmentServiceId, resourceUnits = undefined) {
            return this.$appointmentBookModal.resourceSharing(appointmentServiceId, this, resourceUnits);
        }

        resourceSharingModalAppointmentServiceId;
        resourceSharingModalResourceUnits;
        resourceSharingPreAddEditClient(appointmentServiceId, resourceUnits) {
            this.resourceSharingModalAppointmentServiceId = appointmentServiceId;
            this.resourceSharingModalResourceUnits = resourceUnits;
            this.$appointmentBookModal.hideModal({});
        }

        resourceSharingAddEditClientCallback(model, callbackData) {
            if (Model.Guard.isSomething(model)) {
                this.resourceSharingModalResourceUnits[callbackData].clientType = Model.ClientTypeEnum.Client;
                this.resourceSharingModalResourceUnits[callbackData].id = model.id;
                this.resourceSharingModalResourceUnits[callbackData].client = model;
            }
            this.openResourceSharingAssistant(this.resourceSharingModalAppointmentServiceId, this.resourceSharingModalResourceUnits);
        }

        saveResourceUnitAppointmentServices(appointmentServices) {
            const validServices = appointmentServices.filter(appointmentService => appointmentService.service != undefined &&
                appointmentService.client != undefined);

            this.updateResourceSharingServicesRequestStatus(validServices);

            _(validServices).each(appointmentService => {
                var currentService: any = _.findWhere(this.currentAppointment.services, { id: appointmentService.id });
                if (currentService) {
                    currentService.client = appointmentService.client;
                    currentService.clientId = appointmentService.clientId;
                    currentService.clientType = appointmentService.clientType;

                    currentService.employee = appointmentService.employee;
                    currentService.employeeId = appointmentService.employeeId;

                    currentService.steps = appointmentService.steps;
                    currentService.service = appointmentService.service;
                    currentService.isRequested = appointmentService.isRequested;
                } else {
                    appointmentService.startDate = this.currentDetail.startDate;
                    appointmentService.startTime = this.currentDetail.startTime;
                    appointmentService.startDateTime = this.currentDetail.startDateTime;

                    if (appointmentService.id === this.currentDetail.id) {
                        appointmentService.serviceAddOns = this.currentDetail.serviceAddOns;
                    }

                    this.currentAppointment.services.push(appointmentService);
                }
            });
        }

        private addBlankResource(currentDetail) {
            currentDetail.resources.unshift({
                id: 0,
                displayName: ""
            });
        }

        private clearResource(currentDetail) {
            currentDetail.resource = undefined;
            currentDetail.resourceId = undefined;
            currentDetail.resourceUnitId = undefined;
            this.resourceHasChanged = true;
        }

        private clearEmployee(currentDetail) {
            currentDetail.employee = undefined;
            currentDetail.employeeId = undefined;
            this.serviceAlerts = [];
            this.employeeHasChanged = true;
        }

        checkIfUpdateResources(currentDetail) {
            if (!currentDetail) {
                return;
            }
            currentDetail.resources = undefined;
            if (!currentDetail.resource) {
                this.updateResources(currentDetail);
            }
        }

        private checkEquipment(currentDetail, isEquipmentRequired, isValid): ng.IPromise<{}> {
            if (!isEquipmentRequired || !isValid) {
                return this.$q.resolve(true);
            }

            let siblings = _.filter(this.currentAppointment.services, (service) => service != currentDetail);
            return this.checkEquipmentWorker(currentDetail, siblings);
        }

        public checkSeviceAddOnEquipment(addOns) {
            addOns.forEach(addOn => {
                addOn.appointmentServiceId = this.currentDetail.id;
            });
            let siblings = _.filter(this.currentAppointment.services, (service) => service != this.currentDetail);
            let currentDetailCopy = jQuery.extend(true, {}, this.currentDetail);
            currentDetailCopy.serviceAddOns = addOns;
            this.calculateStepDuration(currentDetailCopy);
            return this.checkEquipmentWorker(currentDetailCopy, siblings);
        }

        private checkEquipmentWorker(currentDetail, siblings) {

            var defer = this.$q.defer();
            this.restServer.getAppointmentServiceEquipment(currentDetail, siblings, (response) => {
                 if (_.where(response, { isAvailable: false }).length > 0) {
                     this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_NO_EQUIPMENT_AVAILABLE", {
                         serviceDisplayName: currentDetail.service.displayName
                     })).then(() => {
                         defer.resolve(false);
                     });
                 }
                 else {
                     defer.resolve(true);
                 }
            });
            return defer.promise;
        }

        private handleServiceNotes(currentDetail, serviceNotes) {
            currentDetail.serviceNoteAlertsCount = serviceNotes.length;
            if (serviceNotes.length === 0) {
                return this.$q.resolve(true);
            }

            currentDetail.serviceNoteAlerts.push({
                alertMessage: serviceNotes[0].noteText,
                alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
            });

            const noteService: Meevo.Plugins.Note.INoteService = {
                entityId: currentDetail.serviceId,
                serviceId: currentDetail.serviceId,
            };

            return this.getAggregatedNotesWithCaching(null, [ noteService ])
                .then(aggregatedNotes => this.actions.displayAggregatedNotes(aggregatedNotes, Meevo.Model.ClientNoteViewTimeEnum.AppointmentBooked, false, true));
        }

        private showCustomControls(currentDetail): any {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/CustomFields.html",
                controller: "meevo.plugins.appointmentbook.CustomFieldsController",
                controllerAs: "vm",
                bindToController: true,
                additionalClassName: 'appointment-custom-fields-modal',
                locals: {
                    appointDetails: [ currentDetail ],
                    appArea: Meevo.Model.AppAreaEnum.Booking,
                    canEdit: this.canEditPermission
                },
                onShowing(_modalScope: ng.IScope, $el) {
                    if ($el && $el[0] instanceof HTMLElement) {
                        ($el[0] as HTMLElement).classList.add('appointment-custom-fields-modal');
                    }
                }
            };
            return this.modalService.showCustom(modalOptions);
        }

        rebuildSteps(currentDetail, serviceChanged) {
            if (!currentDetail) {
                currentDetail = this.currentDetail;
            }
            if (!currentDetail.service) {
                return;
            }

            const serviceId = currentDetail.service.id;
            const employeeId = currentDetail.employee ? currentDetail.employee.id : null;
            const clientId = currentDetail.client ? currentDetail.client.id : null;

            let serviceAddOnIds = _(currentDetail.serviceAddOns).map(serviceAddOn => serviceAddOn.addOnServiceId);

            currentDetail.steps = [];

            return this.restServer.getAppointmentServiceTemplateWithAddOns(
                employeeId,
                serviceId,
                clientId,
                serviceAddOnIds,
                this.getDateTime(currentDetail),
                (response) => {
                    this.serviceAlerts = [];
                    if (serviceChanged) {
                        currentDetail.serviceNoteAlertsCount = 0;
                        currentDetail.serviceNoteAlerts = [];
                    }
                    currentDetail.doNotAllowStepTimingOverride = response.doNotAllowStepTimingOverride;
                    currentDetail.employeePerformsService = response.employeePerformsService;
                    currentDetail.isEnableIntelliBooking = response.isEnableIntelliBooking;
                    if (currentDetail.employee && !response.employeePerformsService) {
                        this.serviceAlerts.push(<PassiveAlert>{
                            alertMessage: this.$translate.instant("MESSAGE_EMPLOYEE_DOES_NOT_PERFORM_SERVICE"),
                            alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.High
                        });
                    }

                    if (currentDetail.genderPreference == null
                        || (currentDetail.genderPreference === Model.GenderPreferenceEnum.NoPreference && !currentDetail.allowGenderPreference)) {
                        // forceGenderPreference
                        currentDetail.genderPreference = response.allowGenderPreference ? null : Model.GenderPreferenceEnum.NoPreference;
                    }

                    currentDetail.allowGenderPreference = response.allowGenderPreference;
                    currentDetail.finalState = response.finalState;
                    currentDetail.transitionState = response.transitionState;
                    currentDetail.price = response.price;
                    currentDetail.totalMinutes = response.totalMinutes;
                    currentDetail.startDateTime = this.getDateTime(currentDetail);
                    currentDetail.serviceId = currentDetail.service.id;
                    currentDetail.isResourceRequired = response.isResourceRequired;
                    currentDetail.hasBookingCustomControls = response.hasBookingCustomControls;
                    currentDetail.hasServiceAddOn = response.hasServiceAddOn;
                    currentDetail.addOnCount = response.addOnCount;
                    currentDetail.serviceAvailableForMale = currentDetail.service.availableForMale;
                    currentDetail.serviceAvailableForFemale = currentDetail.service.availableForFemale;
                    currentDetail.isEquipmentRequired = response.isEquipmentRequired;

                    this.updateSingleServicePrice(currentDetail, serviceId, employeeId, clientId);

                    currentDetail.steps = [];
                    response.steps.forEach((step) => {
                        step.stateEnum = Meevo.Model.StateEnum.Add;
                        step.appointmentServiceId = currentDetail.id;
                        if (!currentDetail.employee) {
                            step.employeeId = null;
                        }
                        currentDetail.steps.push(step);
                    });

                    if (serviceChanged) {
                        this.handleBookingCustomControls(currentDetail, response.hasBookingCustomControls).then(customFieldsResponse => {
                            if (!customFieldsResponse.proceed) {
                                currentDetail.service = undefined;
                                currentDetail.isResourceRequired = false;
                                currentDetail.hasServiceAddOn = false;
                                currentDetail.hasBookingCustomControls = false;
                                this.clearResource(currentDetail);
                                return;
                            }

                            this.handleServiceNotes(currentDetail, response.serviceNotes)
                                .then(() => this.handleServiceChangedResources(currentDetail, response))
                                .then((isValid) => this.checkEquipment(currentDetail, response.isEquipmentRequired, isValid))
                                .then(() => this.handleServiceAddOns(currentDetail, this.serviceAddOnPermission));
                        })
                    }
                    else {
                        this.handleEmployeeChangedResources(currentDetail).then((isValid) => {
                            this.checkEquipment(currentDetail, response.isEquipmentRequired, isValid);
                        })
                    }

                    _(response.serviceAddOns).forEach((serviceAddOn) => {
                        var sAddOn = _.find(currentDetail.serviceAddOns, (sa: any) => sa.addOnServiceId == serviceAddOn.addOnServiceId);
                        if (sAddOn) {
                            sAddOn.price = serviceAddOn.price;
                        }
                    });

                    this.stepOverrideService.initializeStage(currentDetail);

                    this.calculateStepDuration(currentDetail);
                });
        }

        private updateSingleServicePrice(currentDetail, serviceId, employeeId, clientId) {
            if (!serviceId) {
                return;
            }

            if (!this.globals.businessInfo.enableIntegratedRegister) {
                currentDetail.totalPrice = this.calculatePrice(currentDetail);
                return;
            }

            const appointmentServiceId = currentDetail.isNew ? null : currentDetail.id;

            let services = [{
                serviceId,
                employeeId,
                clientId,
                startDateTime: currentDetail.startDateTime,
                appointmentServiceId: appointmentServiceId,
            }];

            _(currentDetail.serviceAddOns).forEach(serviceAddOn => {
                services.push({
                    serviceId: serviceAddOn.addOnServiceId,
                    clientId: clientId,
                    employeeId: employeeId,
                    startDateTime: currentDetail.startDateTime,
                    appointmentServiceId: appointmentServiceId,
                });
            });

            this.restServer.getRegisterPriceList(services, true).then((priceResponse) => {
                const priceRequest = priceResponse.data.services.find(serviceResponse => serviceResponse.priceRequest.serviceId === serviceId);
                currentDetail.price = priceRequest.finalPriceCharge;

                _(currentDetail.serviceAddOns).forEach(serviceAddOn => {
                    const priceRequest = priceResponse.data.services.find(serviceResponse => serviceResponse.priceRequest.serviceId === serviceAddOn.addOnServiceId);
                    serviceAddOn.price = priceRequest.finalPriceCharge;
                });

                currentDetail.totalPrice = this.calculatePrice(currentDetail);
            });
        }

        private handleEmployeeChangedResources(currentDetail) {
            let defer = this.$q.defer();
            this.updateResources(currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: true }).then((isValid) => {
                defer.resolve(isValid);
            });
            return defer.promise;
        }

        private handleServiceChangedResources(currentDetail, response) {
            let defer = this.$q.defer();
            if (!currentDetail.isResourceRequired) {
                this.clearResource(currentDetail);
                currentDetail.resources = undefined;
                defer.resolve(true);
            } else if (currentDetail.resource &&
                !_.findWhere(response.resources, { id: currentDetail.resource.id })) {
                const message = this.$translate.instant("MESSAGE_RESOURCE_SERVICE_NOT_DEFINED", {
                    serviceDisplayName: currentDetail.service.displayName,
                    resourceDisplayName: currentDetail.resource.displayName
                });
                this.$appointmentBookModal.showMessage(message).then(() => {
                    this.updateResources(currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: true, clearResource: true, showUnavailableMessage: false }).then((isValid) => {
                        defer.resolve(isValid);
                    });
                });
            } else {
                this.updateResources(currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: true }).then((isValid) => {
                    defer.resolve(isValid);
                });
            }
            return defer.promise;
        }

        private handleServiceAddOns(currentDetail, serviceAddOnPermission) {
            let defer = this.$q.defer();
            if (serviceAddOnPermission && currentDetail.hasServiceAddOn) {
                //Timeout for the time it takes the typeahead dropdown to close and the mobile keyboard to disappear
                this.$timeout(() => {
                    this.showServiceAddOnsModal(currentDetail, true).then(() => {
                        defer.resolve(true);
                    });
                }, 500);
            }
            else {
                defer.resolve(true);
            }
            return defer.promise;
        }

        private handleBookingCustomControls(currentDetail, hasBookingCustomControls) {
            if (hasBookingCustomControls) {
                return this.showCustomControls(currentDetail);
            }
            return this.$q.resolve({ proceed: true });
        }

        private appointHeader;
        private affectedColumns;
        appointHeaderInPastWarningCallback = (response) => {
            if (response == Meevo.Model.MessageBoxButtonResult.Yes) {
                this.saveAppointment(this._saveAppointmentData, null);
            }
        }

        getDateTime(appointmentService) {
            var appointmentServiceStartDate = this.currentAppointment.appointmentDate;
            var appointmentServiceStartTime = appointmentService.startTime;

            return moment(appointmentServiceStartDate).startOf('day')
                .hours(moment(appointmentServiceStartTime).hours())
                .minutes(moment(appointmentServiceStartTime).minutes())
                .toDate();
        }

        validateAppointmentService(service) {

            const isGenderRequiredAndMissing = this.isGenderPreferenceRequired() && !service.genderPreference;

            if (!service.service || !service.client || (service.isResourceRequired && !service.resource) || (this.employeeRequired(service) && !service.employee) || (service.isRequested === undefined) ||
                (service.service.isAddressRequired && (!service.address1 || service.address1.trim() === "" ||
                    !service.city || service.city.trim() === "" ||
                    !service.state || service.state.trim() === "" ||
                    !service.zipCode || service.zipCode.trim() === ""))
                || isGenderRequiredAndMissing) {
                this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_APPOINTMENT_EDITOR_REQUIRED_PROCEED")).then(() => {
                    if (((service.isResourceRequired && !service.resource) || (service.isRequested === undefined)) &&
                        (!this.currentDetail || (this.currentDetail && this.currentDetail.id !== service.id))) {
                        this.selectAppointDetail(service.id, false);
                    }
                });
            } else {
                return true;
            }
            return false;
        }

        private _saveAppointmentData;
        saveAppointment(workflowData, callbackFunc) {

            this._saveAppointmentData = workflowData || {};

            if (!isObject(this.currentAppointment.payingClient) && (this.currentAppointment.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousFemale
                && this.currentAppointment.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousMale
                && this.currentAppointment.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousOther)) {
                this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_PAYING_CLIENT_REQUIRED_PROCEED"));
                return;
            }

            if (this.currentAppointment.services.length === 0) {
                if ((this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.Client && !this.currentDetail.client) &&
                    (!(this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.AnonymousMale ||
                        this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                        this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.AnonymousOther))) {
                    this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_SERVICING_CLIENT_REQUIRED_PROCEED"));
                }
                else {
                    this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_SERVICE_REQUIRED_PROCEED"));
                }
                return;
            }

            if (!this.isFromWaitList &&
                this.globals.businessInfo.showAppointmentCategory &&
                this.globals.businessInfo.requireAppointmentCategory &&
                !this.currentAppointment.appointCat) {
                this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_APPOINTMENT_CATEGORY_REQUIRED_PROCEED"));
                return;
            }

            this.affectedColumns = [];
            this.appointHeader = this.currentAppointment;

            if (this.appointHeader.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousFemale
                && this.appointHeader.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousMale
                && this.appointHeader.payingClientType !== Meevo.Model.ClientTypeEnum.AnonymousOther) {
                this.appointHeader.payingClientId = this.appointHeader.payingClient.id;
            } else {
                this.appointHeader.payingClientId = null;
            }

            this.appointHeader.appointmentCategoryId = this.appointHeader.appointCat != undefined ? this.appointHeader.appointCat.id : null;

            let invalidService = _.find(this.currentAppointment.services, (service: any) => {
                return !this.validateAppointmentService(service);
            });
            if (invalidService) {
                return;
            }

            var isValid = true;
            let appointmentServiceSequence = 1;
            this.currentAppointment.services.forEach((appointmentService) => {

                if (appointmentService.steps.length === 0) {
                    this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_STEP_HAS_ZERO_TOTAL_MINUTES"));
                    isValid = false;
                    return;
                }

                var totalMinutes = 0;
                appointmentService.employeeId = appointmentService.employee ? appointmentService.employee.id : undefined;
                appointmentService.steps.forEach((step) => {
                    totalMinutes += step.durationWithAddOnsInMinutes;
                    step.employeeId = appointmentService.employeeId;
                    step.appointmentServiceId = appointmentService.id;
                });

                if (totalMinutes == 0) {
                    this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_STEP_HAS_ZERO_TOTAL_MINUTES"));
                    isValid = false;
                    return;
                }

                for (let index = appointmentService.steps.length; index--;) {
                    if (appointmentService.steps[index].stateEnum === Meevo.Model.StateEnum.Delete) {
                        appointmentService.steps.splice(index, 1);
                    }
                }

                if (!appointmentService.service.isAddressRequired) {
                    appointmentService.address1 = undefined;
                    appointmentService.address2 = undefined;
                    appointmentService.city = undefined;
                    appointmentService.state = undefined;
                    appointmentService.zipCode = undefined;
                    appointmentService.country = undefined;
                }

                appointmentService.appointmentEditorSequenceNumber = appointmentServiceSequence++;
                appointmentService.startDateTime = this.getDateTime(appointmentService);

                var originalAppointmentDate;

                if (appointmentService.clientType !== Meevo.Model.ClientTypeEnum.AnonymousFemale
                    && appointmentService.clientType !== Meevo.Model.ClientTypeEnum.AnonymousMale
                    && appointmentService.clientType !== Meevo.Model.ClientTypeEnum.AnonymousOther) {
                    if (appointmentService.client) {
                        appointmentService.clientId = appointmentService.client.id;
                        if (appointmentService.client.gender) {
                            appointmentService.clientGender = appointmentService.client.gender;
                        }
                    }
                } else {
                    appointmentService.clientId = null;
                    if (appointmentService.clientType === Meevo.Model.ClientTypeEnum.AnonymousFemale) {
                        appointmentService.clientGender = Model.GenderEnum.Female;
                    }
                    else if (appointmentService.clientType === Meevo.Model.ClientTypeEnum.AnonymousMale) {
                        appointmentService.clientGender = Model.GenderEnum.Male;
                    }
                    else if (appointmentService.clientType === Meevo.Model.ClientTypeEnum.AnonymousOther) {
                        appointmentService.clientGender = Model.GenderEnum.Other;
                    }
                    else {
                        appointmentService.clientGender = undefined;
                    }
                }


                appointmentService.serviceId = appointmentService.service.id;
                appointmentService.serviceCategoryId = appointmentService.service.serviceCategoryId;
                appointmentService.appointTypeItemId = appointmentService.appointType != undefined ? appointmentService.appointType.id : null;
                appointmentService.serviceDisplayName = appointmentService.service.displayName;
                appointmentService.serviceShortcut = appointmentService.service.shortcut;
                appointmentService.isAddressRequired = appointmentService.service.isAddressRequired;

                if (this.isGenderPreferenceRequired() && (appointmentService.genderPreference === null || appointmentService.genderPreference === 0)) {
                    this.$appointmentBookModal.showMessage(this.$translate.instant("ERROR_GENDER_PREFERENCE_REQUIRED_PROCEED"));
                    isValid = false;
                    return;
                }

                this.saveServiceCheckboxes(appointmentService);

                if (appointmentService.clientType === null) {
                    appointmentService.clientType = Meevo.Model.ClientTypeEnum.Client;
                }

                if (appointmentService.startDate && appointmentService.startDate != this.currentAppointment.appointmentDate) {
                    originalAppointmentDate = moment(appointmentService.startDate).toDate();
                    appointmentService.startDate = this.currentAppointment.appointmentDate;
                    this.setState(appointmentService, Meevo.Model.StateEnum.Edit);
                }

                if (appointmentService.isNew) {
                    // allow the server to re-guid the new appointment service with a sequential guid
                    appointmentService.id = undefined;
                }

                var originalIdToRefresh = this.globals.isEmployeeView ? appointmentService.originalEmployeeId : appointmentService.originalResourceId;
                var idToRefresh = this.globals.isEmployeeView ? this.getId(appointmentService.employee) : this.getId(appointmentService.resource);

                this.affectedColumns.push({ date: moment(originalAppointmentDate), entityId: originalIdToRefresh });
                this.affectedColumns.push({ date: moment(this.appointHeader.appointmentDate), entityId: idToRefresh });
            });

            this.setNoteType();
            if (isValid) {
                this.busyService.start();
                this.appointHeader.saveOrigin = Model.AppointmentSaveOriginEnum.AppointmentEditor;
                this.restServer.saveAppointHeader(this.appointHeader, (r, ed) => this.saveAppointHeaderCallback(r, ed, callbackFunc),
                    w => this.saveAppointHeaderCallBackWarnings(w, callbackFunc), null, null,
                    data => this.saveAppointHeaderFailure(data));
            }
        }

        private getId(entity) {
            return entity ? entity.id : undefined;
        }

        private saveAppointHeaderCallBackWarnings(warnings: Meevo.Plugins.AppointmentBook.Models.WarningList, callbackFunc: any) {
            this.$appointmentBookModal.showMessages(warnings, "HEADER_APPOINTMENT_WARNING", { buttonsType: Meevo.Model.ButtonTypeEnum.YesNo, callback: (r) => this.checkWarningCallback(r, callbackFunc) });
        }

        private saveAppointHeaderFailure(data) {
            let customState = data && data.responseStatus && data.responseStatus.errors && data.responseStatus.errors.length &&
                data.responseStatus.errors[0].customState;
     
            if (!customState || !customState.isAppointmentEditorReload) {
                return;
            }

            let editingServices = angular.copy(this.currentAppointment.services);
            for (let service of editingServices) {
                // assign guid to any new services since we clear it out upon save
                if (service.isNew) {
                    service.id = NewGuid();
                }
            }

            this.openAppointment(customState.appointmentId, customState.appointmentServiceId).then(() => {
                let editingServiceIds = _(editingServices).pluck("id");
                //only keep services that didn't already exist in editor.  services that already exist, but are being edited will be re-added
                this.currentAppointment.services = this.currentAppointment.services.filter(
                    service => editingServiceIds.indexOf(service.id) == -1)
                this.currentAppointment.services.push(...editingServices);
            })
        }

        private saveCustomControls(savedAppointmentService): angular.IPromise<void> {
            let clientAppointmentService: any = _.findWhere(this.currentAppointment.services,
                { "appointmentEditorSequenceNumber": savedAppointmentService.appointmentEditorSequenceNumber });
            if (clientAppointmentService && clientAppointmentService.customControlsAnswers) {
                let controlAnswers = clientAppointmentService.customControlsAnswers;
                controlAnswers.answers.forEach((answer) => {
                    answer.entity_Id = savedAppointmentService.id;
                    answer.appAreaEnum = Model.AppAreaEnum.Booking;
                    answer.auditEntityId = savedAppointmentService.appointmentId;
                });
                let data = {
                    answers: controlAnswers.answers,
                    answerItems: controlAnswers.answerItems
                };

                return this.dataService.add(`customData/Answer`, data);
            } else {
                var defer = this.$q.defer<void>();
                defer.resolve();
                return defer.promise;
            }
        }

        private saveAppointHeaderCallback(response, extraData, callbackFunc) {

            this.currentAppointment.services.forEach((appointmentService) => {
                this.stepOverrideService.save(appointmentService, appointmentService.client, response.id, Model.NounEnum.Appointment).then(() => {
                    for (let columnBooking of this.globals.columnBookings) {
                        const entity = _.find(columnBooking.appointmentsAndBlocks, (entry: any) => entry.id === appointmentService.id);
                        if (entity) {
                            entity.steps = appointmentService.steps;
                        }
                    }
                });
            });

            if (callbackFunc) {
                callbackFunc(response);
            }

            let promises = [];
            for (var i = 0; i < response.services.length; i++) {
                promises.push(this.saveCustomControls(response.services[i]));
            }
            this.$q.all(promises)
                .then(() => {
                    const finishCallback = () => {
                        var redraw = false;
                        response.services.forEach((service) => {
                            if (moment.duration(moment(service.startDateTime).format("H:mm:ss")) <
                                moment.duration(this.globals.bookStartTime)) {
                                redraw = true;
                            }
                        });
                        this.helper.loadCounts(this.resourceHasChanged, this.employeeHasChanged, this.filterActions.dates);
                        this.$rootScope.$broadcast("appointmentSaved", {
                            affectedColumns: this.affectedColumns,
                            relatedAppointmentRequests: (this.isFromWaitList)
                                ? response.relatedAppointmentRequests
                                : null,
                            redrawApptBook: redraw,
                            appointmentId: response.id,
                            originalAppointmentId: this.currentAppointment.id
                        });

                        this.showDocsAndForms(response);
                        this.isFromWaitList = false;
                        if (this.pendingAppointmentIdToDelete) {
                            var appointService = {
                                id: this.pendingIdToDelete,
                                appointmentId: this.pendingAppointmentIdToDelete,
                                isFromWaitList: this.isFromWaitList
                            };
                            this.actions.deletePendingAppointment(appointService);
                        }

                        if ((!this.globals.isEmployeeView) && extraData && extraData.multipleChoiceResponse && extraData.multipleChoiceResponse == "AutoAssignResources") {
                            this.filterActions.refresh();
                        }
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.BOOK_APPOINTMENT_FOR_CLIENT, {isFromStanding: this.isFromStanding});
                        this.helper.checkReturnToState(this, true);
                    };

                    if (!this.isFromWaitList) {
                        this.checkRelatedAppointmentRequests(response).then(() => finishCallback());
                        return;
                    }

                    finishCallback();
                });
        }

        private showDocsAndForms(response) {
            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_FORMS)
                .then((result) => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        let existingAppointmentServiceIds = _(this.currentAppointment.services).chain().filter((service) => service.id).pluck("id").value();
                        let newAppointmentServiceIds = _(response.services).chain().filter((service) => service.clientType == Model.ClientTypeEnum.Client &&
                            existingAppointmentServiceIds.indexOf(service.id) == -1).pluck("id").value();

                        if (newAppointmentServiceIds.length > 0) {
                            let request = {
                                "AppointmentServicesList": newAppointmentServiceIds,
                                "TriggerEventEnum": Meevo.Model.DocsAndFormsTriggerEventEnum.Booked,
                                "IsPrompted": true,
                                "isBuilt": true
                            };
                            this.$q.all([
                                this.dataService.customMethodData('api/DocsAndForms/AppointmentServiceForm/List', 'post', request),
                                this.meevoMessengerApiService.getLocationTime()
                            ]).then(([formsResponse, locationTime]) => {

                                let unsubmittedForms = _(formsResponse.data as IClientFormService[])
                                    .filter((form) => {
                                        if (!form.isSubmitted) return true;

                                        if (form.expirationDate) {
                                            return moment(locationTime).diff(moment(form.expirationDate)) > 0;
                                        } else {
                                            return false;
                                        }
                                    });
                                if (unsubmittedForms.length > 0) {
                                    this.$appointmentBookModal.showDocsAndForms(unsubmittedForms, Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.Booking, request);
                                }
                            });
                        }
                    }
                });
        }

        relatedAppointmentRequests: any;
        private checkRelatedAppointmentRequests(response) {
            if (response.relatedAppointmentRequests && response.relatedAppointmentRequests.length > 0) {
                let message;
                let messageConfig = { serviceList: '', clientList: '' };
                this.relatedAppointmentRequests = response.relatedAppointmentRequests;
                if (response.relatedAppointmentRequests.length == 1) {
                    message = "MESSAGE_DELETE_EXISTING_APPOINTMENT_REQUEST";

                    for (let service of response.relatedAppointmentRequests[0].services) {
                        if (messageConfig.serviceList != "") {
                            messageConfig.serviceList += ", ";
                        }
                        messageConfig.serviceList += service.serviceDisplayName;
                    }
                } else {
                    message = "MESSAGE_DELETE_EXISTING_APPOINTMENT_REQUESTS";

                    for (let appointmentRequest of response.relatedAppointmentRequests) {
                        if (messageConfig.clientList != "") {
                            messageConfig.clientList += ", ";
                        }
                        messageConfig.clientList += `${appointmentRequest.clientLastName}, ${appointmentRequest.clientFirstName}`;
                        for (let service of appointmentRequest.services) {
                            if (messageConfig.serviceList != "") {
                                messageConfig.serviceList += ", ";
                            }
                            messageConfig.serviceList += service.serviceDisplayName;
                        }
                    }
                }

                return this.$appointmentBookModal.showMessage(this.$translate.instant(message, messageConfig), {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo, callback: (result) => {
                        if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                            this.deleteAppointmentRequest(0);
                        }
                    }
                });
            }

            return this.$q.resolve();
        }

        // This needs to be called serially for multiple appointment requests to prevent a race condition with the version number.   Also need to call
        // a patch instead of a delete b/c of version number issues with multiple
        private deleteAppointmentRequest(relatedAppointmentRequestIndex) {
            if (relatedAppointmentRequestIndex == this.relatedAppointmentRequests.length) {
                return;
            }
            this.restServer.patchAppointmentRequest(this.relatedAppointmentRequests[relatedAppointmentRequestIndex].id, true, false, () => {
                this.deleteAppointmentRequest(++relatedAppointmentRequestIndex);
            });
        }

        private checkWarningCallback(result, callbackFunc) {
            if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                this.appointHeader.suppressWarnings = true;
                this.busyService.start();
                this.restServer.saveAppointHeader(this.appointHeader, (r, ed) => this.saveAppointHeaderCallback(r, ed, callbackFunc), w => this.saveAppointHeaderCallBackWarnings(w, callbackFunc));
            }
        }

        setNoteType() {
            if (this.currentAppointment.note != undefined) {
                if (this.local.noteType != undefined && this.local.noteType.id != undefined) {
                    this.currentAppointment.noteType = this.local.noteType.id;
                } else {
                    this.currentAppointment.noteType = Meevo.Model.AppointNoteTypeEnum.AppointmentBookOnly;
                }
            }
        }

        preventNotificationsClicked(client: any, preventNotificationsValue: boolean) {
            var clientServices = this.getClientServices(this.currentAppointment.services, client);
            for (let clientService of clientServices) {
                clientService.preventNotifications = preventNotificationsValue;
            }
        }

        areNotificationsPrevented(client) {
            return this.getClientServices(this.currentAppointment.services, client)[0].preventNotifications;
        }

        canAddEdit() {
            return (this.currentAppointment
                && ((!this.currentAppointment.id && this.canAddPermission && this.currentAppointment.isLocal)
                    || (this.currentAppointment.id && this.canEditPermission && this.currentAppointment.isLocal))) && !this.isReadOnly;
        }

        canAdd() {
            return this.canAddPermission && this.currentAppointment && !this.currentAppointment.id && this.currentAppointment.isLocal;
        }

        canEdit() {
            return this.canEditPermission && this.currentAppointment && this.currentAppointment.isLocal && !this.isReadOnly;
        }

        isServiceVisible() {
            let list = _.chain(this.currentAppointment.services)
                .pluck('id')
                .difference(this.globals.deletedIds)
                .value();

            return this.currentAppointment && list.length > 1;
        }

        isDeleteVisible() {
            let visible = this.currentAppointment && this.currentAppointment.isLocal && this.currentAppointment.id != undefined;
            if (!visible) return false;

            let list = _.chain(this.currentAppointment.services)
                .filter((service) => !service.isNew)
                .pluck('id')
                .difference(this.globals.deletedIds)
                .value();

            return list.length > 0;
        }

        updateEmployeeCriteria(currentDetail?: any) {
            this.employeeCriteria = { showEmployeesOnly: true, includeSharedEmployee: true }
            if (currentDetail && currentDetail.service) {
                this.employeeCriteria.serviceIdList = [currentDetail.service.id];
            }
        }

        selectAppointDetail(appointmentServiceId, validate: boolean = true) {
            if (this.currentDetail && validate) {
                if (_(this.currentAppointment.services).findWhere({ id: this.currentDetail.id }) &&
                    !this.validateAppointmentService(this.currentDetail)) {
                    return;
                }
            }

            this.clientMembershipAlerts = [];
            this.clientAlerts = [];
            this.clientGiftCardAlerts = [];
            this.serviceAlerts = [];
            this.hideServicingClientAlerts();
            this.currentDetail = _.where(this.currentAppointment.services, { id: appointmentServiceId })[0];
            this.currentDetail.ignoreServicingClientChange = true;
            this.updateEmployeeCriteria(this.currentDetail);
            this.refreshServiceCriteria();
            this.clientNotes = [];

            if (this.currentDetail.employee && !this.currentDetail.employeePerformsService) {
                this.serviceAlerts.push(<PassiveAlert>{
                    alertMessage: this.$translate.instant("MESSAGE_EMPLOYEE_DOES_NOT_PERFORM_SERVICE"),
                    alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.High
                });
            }

            var startTime = moment(this.currentDetail.startTime);

            this.currentDetail.startTimeSegmented = {
                value: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), Number(startTime.format("HH")), Number(startTime.format("mm")))
            };
            this.getServiceNotesCount(this.currentDetail);
            this.getServicingClientNotes(this.currentDetail.client);

            if (this.currentDetail.client) {
                this.checkForClientMissingFieldAlert(this.currentDetail.client.id, this.clientAlerts, true);
                this.getClientMembershipInfo(new Array(this.currentDetail.client.id));
                if (!this.currentDetail.client.clientCardsOnFile) {
                    this.getClientCardOnFile(this.currentDetail.client.id);
                }
            }
        }

        private getServiceNotesCount(currentDetail) {
            if (currentDetail.service && !currentDetail.serviceNoteAlertsCount) {
                var request: any = {
                    pageNumber: 0,
                    itemsPerPage: 1,
                    sortDirection: Meevo.Model.SortDirection.Descending,
                    criteria: {
                        filter: ''
                    }
                }
                this.dataService.getCount("service", request, currentDetail.serviceId, "Notes").then((response) => {
                    currentDetail.serviceNoteAlertsCount = response;
                });
            }
        }

        private indexedClients = [];

        appointDetailsToFilter() {
            this.indexedClients = [];
            return this.currentAppointment.services;
        }

        appointDetailClients() {
            var uniqueClients = [];
            var uniqueClientIds = [];
            if (this.currentAppointment != undefined) {
                this.currentAppointment.services.forEach((appointmentService) => {
                    if (appointmentService.transitionState === Meevo.Model.AppointStateEnum.Pending)
                        return;

                    var id = -1; //Account for anon clients with no ids
                    if (appointmentService.client !== undefined) {
                        id = appointmentService.client.id || appointmentService.clientType;
                    }

                    if (uniqueClientIds.indexOf(id) === -1) {
                        uniqueClientIds.push(id);
                        uniqueClients.push(appointmentService.client);
                    }
                });
            }
            return uniqueClients;
        }

        filterAppointDetailByClient(appointDetail) {
            var clientIsNew = this.indexedClients.indexOf(appointDetail.client.id);
            if (clientIsNew) {
                this.indexedClients.push(appointDetail.client.id);
            }
            return clientIsNew;
        }

        filterDisplayStep(step) {
            return step.stateEnum === Meevo.Model.StateEnum.Add || step.stateEnum === Meevo.Model.StateEnum.Edit || step.stateEnum === Meevo.Model.StateEnum.Read;
        }

        currentDetailChanged() {
            this.setState(this.currentDetail, Meevo.Model.StateEnum.Edit);
        }

        private copyClientAddress(currentDetail) {
            if (currentDetail.client && currentDetail.service && currentDetail.service.isAddressRequired) {
                let existingServiceWithClientAddress = _(this.currentAppointment.services).find((service) => {
                    return service.service.isAddressRequired &&
                        service.client &&
                        service.client.id === currentDetail.client.id;
                });
                if (existingServiceWithClientAddress) {
                    this.setAddressOfAppointmentService(existingServiceWithClientAddress);
                    return true;
                }
            }
            return false;
        }

        serviceChanged() {
            this.currentDetail.customControlsAnswers = undefined;
            this.currentDetail.hasServiceAddOn = false;
            this.currentDetail.addOnCount = 0;
            this.currentDetail.serviceAddOns = [];

            if (isObject(this.currentDetail.service)) {
                this.setState(this.currentDetail, Meevo.Model.StateEnum.Edit);
                this.rebuildSteps(this.currentDetail, true);
                this.copyClientAddress(this.currentDetail);
            } else {
                this.serviceAlerts = [];
                this.currentDetail.serviceNoteAlertsCount = 0;
                this.currentDetail.serviceNoteAlerts = [];
                this.clearResource(this.currentDetail);
            }
            this.updateEmployeeCriteria(this.currentDetail);
            this.refreshServiceCriteria();
            this.checkImplicitAdd();
        }

        getAddOnCount(apptServiceId) {
            var apptService: any = _.findWhere(this.currentAppointment.services, { id: apptServiceId });
            if (apptService.serviceAddOns && apptService.serviceAddOns.length > 0) {
                return "|" + apptService.serviceAddOns.length + "A|";
            } else {
                return "";
            }
        }

        onNoPayingClientIndicatorsFound() : void {
            if (!this.payingClientNotes || this.payingClientNotes.length === 0) {
                this.hidePayingClientAlerts();
            }
        }

        onNoServicingClientIndicatorsFound() : void {
            if (!this.clientNotes || this.clientNotes.length === 0) {
                this.hideServicingClientAlerts();
            }
        }

        clearSelectedService(editorService) {
            if (isObject(editorService.currentDetail.service)) {
                editorService.currentDetail.service = [];
                this.refreshServiceCriteria();
            }
        }

        setAddressOfAppointmentService(address: any = undefined, obj: any = undefined) {
            address = address || {}
            address.address1 = address.address1 || "";
            address.address2 = address.address2 || "";
            address.city = address.city || "";
            address.state = address.state || "";
            address.zipCode = address.zipCode || "";

            if (obj == undefined) {
                obj = this.currentDetail;
            }
            if (this.isCurrentAddressEmpty(obj) || !this.hasAddressChanged(obj)) {
                this.currentDetail.address1 = address.address1;
                this.currentDetail.address2 = address.address2;
                this.currentDetail.city = address.city;
                this.currentDetail.state = address.state;
                this.currentDetail.zipCode = address.zipCode;
                this.setOriginalAddress(this.currentDetail);
            }
        }

        setOriginalAddress(appointmentService) {
            appointmentService.originalAddress = {
                address1: appointmentService.address1,
                address2: appointmentService.address2,
                city: appointmentService.city,
                state: appointmentService.state,
                zipCode: appointmentService.zipCode
            }
        }

        isCurrentAddressEmpty(obj: any = undefined) {
            if (obj == undefined) {
                obj = this.currentDetail;
            }
            return (!obj.address1 || obj.address1.trim() === "") &&
                (!obj.address2 || obj.address2.trim() === "") &&
                (!obj.city || obj.city.trim() === "") &&
                (!obj.state || obj.state.trim() === "") &&
                (!obj.zipCode || obj.zipCode.trim() === "");
        }

        hasAddressChanged(obj: any = undefined) {
            if (obj == undefined) {
                obj = this.currentDetail;
            }
            return obj.originalAddress &&
                (obj.originalAddress.address1 !== obj.address1 ||
                    obj.originalAddress.address2 !== obj.address2 ||
                    obj.originalAddress.city !== obj.city ||
                    obj.originalAddress.state !== obj.state ||
                    obj.originalAddress.zipCode !== obj.zipCode);
        }

        servicingClientChanged(changeType: string, isAddNewClient: boolean = false) {
            this.currentDetail.stepOverrideStage = Meevo.Model.StepOverrideStageEnum.None;

            this.clientMembershipAlerts = [];
            this.clientPointsAlerts = [];
            this.clientAlerts = [];
            this.clientGiftCardAlerts = [];
            this.hideServicingClientAlerts();
            this.clientNotes = [];

            if (changeType === "ClientType") {
                if (this.currentDetail.clientType && this.currentDetail.clientType != ClientTypeEnum.Client) {
                    //anon changed
                    this.currentDetail.client = {
                        id: undefined,
                        clientType: this.currentDetail.clientType,
                        displayName: this.getAnonymousClientName(this.currentDetail.clientType)
                    }
                    this.setAddressOfAppointmentService();
                }
            } else if (isObject(this.currentDetail.client)) {
                if (!this.copyClientAddress(this.currentDetail)) {
                    this.dataService.getItem("client", this.currentDetail.client.id)
                    .then((response: any) => {
                        this.setAddressOfAppointmentService(response.address);
                    });
            }
                let payingClientChanged = false;
                if (this.currentAppointment.payingClient == undefined) {
                    payingClientChanged = true;
                    this.currentAppointment.payingClient = this.currentDetail.client;
                    this.$timeout(() => this.payingClientChanged("Client", false), 0);
                }
                if (this.currentDetail.client) {
                    this.currentDetail.clientId = this.currentDetail.client.id;
                    this.hasServicingClientAlert();
                }

                this.checkClientBirthday(this.currentDetail.client);
                this.getClientCardOnFile(this.currentDetail.client.id);
                if (this.optInClientSelectionAfterActions) {    //rebook, waitlist, standing opt out from these prompts
                    this.checkClientRestrictedWarning(this.currentDetail.client)
                        .then(() => this.referralService.displayReferralsSinceClientLastVisit([this.currentDetail.client]))
                        .then(() => this.checkBookingTimeClientNotes(this.currentDetail.client))
                        .then(() => this.getServicingClientNotes(this.currentDetail.client))
                        .then(() => this.checkClientMembershipCreditCardZipMissing(this.currentDetail.client))
                        .then(() => this.checkPayingClientCardOnFile(this.currentAppointment.payingClient, payingClientChanged));
                }
                this.currentDetail.clientType = ClientTypeEnum.Client;

            }
            else {
                delete this.currentDetail.clientTypeId;
            }

            if (this.currentAppointment.services.length > 1) {
                var earliestApptService = this.currentAppointment.services[0];

                if (this.currentAppointment.services.length > 2) {
                    earliestApptService = _.sortBy(this.currentAppointment.services, (apptService: any) => { return apptService.startTime; })[0];
                }

                if (this.currentDetail.clientId != undefined && ((earliestApptService.clientType != this.currentDetail.clientType) || (earliestApptService.clientType == ClientTypeEnum.Client && earliestApptService.client && earliestApptService.client.id != this.currentDetail.clientId))) {
                    this.currentDetail.startTime = earliestApptService.startTime;
                    this.currentDetail.startTimeSegmented = {
                        value: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), Number(moment(this.currentDetail.startTime).format("HH")), Number(moment(this.currentDetail.startTime).format("mm")))
                    };

                    this.currentDetail.startDateTime = this.getDateTime(this.currentDetail);
                }
            }

            this.setState(this.currentDetail, Meevo.Model.StateEnum.Edit);
            this.checkImplicitAdd();
            if (this.currentDetail.client) {
                const overrideExisting = !!this.currentAppointment.services && this.currentAppointment.services.length > 0;

                this.updateResources(this.currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: overrideExisting });
                this.getClientMembershipInfo(new Array(this.currentDetail.client.id));
            }

            this.rebuildSteps(this.currentDetail, isAddNewClient);
            this.updateRequestedState();
        }

        getAnonymousClientName(clientType, clientDisplayName = undefined) {
            return this.helper.getAnonymousClientName(clientType, clientDisplayName);
        }

        payingClientAddEdit(model, callbackData, callbackContext) {
            if (!model) {
                return;
            }

            let isAdd = callbackContext.typeaheadMode === Model.TypeaheadMode.Add;
            let isEdit = callbackContext.typeaheadMode === Model.TypeaheadMode.Edit &&
                this.currentAppointment.payingClient &&
                this.currentAppointment.payingClient.id === model.id;

            if (isAdd || isEdit) {
                this.currentAppointment.payingClient = model;
                this.payingClientChanged("Client", isEdit);
            }
        }

        payingClientChanged(changeType: string, isEdit: boolean = false) {
            this.payingClientMembershipAlerts = [];
            this.payingClientPointsAlerts = [];
            this.payingClientAlerts = [];
            this.payingClientGiftCardAlerts = [];
            this.hidePayingClientAlerts();

            let continueLogic = () => {
                this.checkIfUpdateResources(this.currentDetail);

                if (this.currentAppointment.payingClient) {
                    this.getClientMembershipInfo([ this.currentAppointment.payingClient.id ]);
                }
            }

            let updateServicingClientType = (isUpdating: boolean) => {
                if (isUpdating) {
                    this.clientNotes = [];
                    this.currentDetail.clientType = this.currentAppointment.payingClientType;
                    this.currentDetail.client = {
                        id: undefined,
                        clientType: this.currentDetail.clientType,
                        displayName: this.getAnonymousClientName(this.currentDetail.clientType),
                    }
                    this.currentDetail.ignoreServicingClientChange = true;

                    _(this.currentAppointment.services).each(appointmentService => {
                        if (appointmentService.id != this.currentDetail.id) {
                            appointmentService.clientType = this.currentAppointment.payingClientType;
                            appointmentService.client = {
                                id: undefined,
                                clientType: this.currentDetail.clientType,
                                displayName: this.getAnonymousClientName(this.currentDetail.clientType)
                            }
                        }
                    });

                    this.setAddressOfAppointmentService();
                    this.hideServicingClientAlerts();
                }

                this.checkImplicitAdd();

                this.currentAppointment.confirmState = Model.ConfirmStateEnum.Unconfirmed;

                continueLogic();
            }

            let updateServicingClient = (isUpdating: boolean) => {
                let servicingClientChanged = false;

                if (isUpdating) {
                    this.hideServicingClientAlerts();
                    this.currentDetail.clientType = ClientTypeEnum.Client;
                    this.currentDetail.client = this.currentAppointment.payingClient;
                    this.currentDetail.ignoreServicingClientChange = true;
                    this.currentDetail.depositAmount = null;

                    servicingClientChanged = true;

                    this.rebuildSteps(this.currentDetail, false);

                    _(this.currentAppointment.services).each(appointmentService => {
                        if (appointmentService.id != this.currentDetail.id) {
                            appointmentService.client = this.currentAppointment.payingClient;
                            this.rebuildSteps(appointmentService, false);
                        }
                    });

                    this.dataService.getItem("client", this.currentDetail.client.id).then((response: any) => {
                        this.setAddressOfAppointmentService(response.address);

                        if (response.clientTypes.length) {
                            this.hasServicingClientAlert();
                            this.currentDetail.clientTypeId = response.clientTypes[0].id;
                        }
                    });

                    this.checkClientBirthday(this.currentDetail.client);
                }

                this.checkClientRestrictedWarning(this.currentAppointment.payingClient).then(() => {
                    var clientNoteCheckResult;

                    if (servicingClientChanged) {
                        clientNoteCheckResult = this.referralService.displayReferralsSinceClientLastVisit([ this.currentDetail.client ])
                            .then(() => this.checkBookingTimeClientNotes(this.currentDetail.client))
                            .then(() => this.getServicingClientNotes(this.currentDetail.client));

                        this.getClientCardOnFile(this.currentDetail.client.id);
                    } else {
                        clientNoteCheckResult = this.$q.resolve();
                    }

                    clientNoteCheckResult
                        .then(() => this.checkClientMembershipCreditCardZipMissing(this.currentAppointment.payingClient))
                        .then(() => this.checkPayingClientCardOnFile(this.currentAppointment.payingClient, !isEdit));
                });

                this.currentAppointment.payingClientType = ClientTypeEnum.Client;
                this.currentAppointment.payingClient.payingClientType = ClientTypeEnum.Client;

                this.checkImplicitAdd();

                this.currentAppointment.confirmState = this.currentAppointment.payingClient.doNotConfirm ? Model.ConfirmStateEnum.DoNotConfirm : Model.ConfirmStateEnum.Unconfirmed;

                continueLogic();
            }

            let payingClientTypeChanged = () => {
                if (this.currentAppointment.payingClientType && this.currentAppointment.payingClientType != ClientTypeEnum.Client) {
                    //anon changed
                    this.currentAppointment.payingClient = {
                        id: undefined,
                        clientType: this.currentAppointment.payingClientType,
                        displayName: this.getAnonymousClientName(this.currentAppointment.payingClientType)
                    }

                    if (!this.currentDetail.clientType || (this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.Client && !this.currentDetail.client)) {
                        updateServicingClientType(true);
                    } else {
                        const distinctServicingClient = this.getDistinctServicingClient();

                        if (distinctServicingClient &&
                            distinctServicingClient.clientType !== this.currentAppointment.payingClient.clientType) {

                            const anyServiceClientHasDeposit = this.anyServicingClientHasDeposit();
                            const message = anyServiceClientHasDeposit
                                ? this.$translate.instant("MESSAGE_UPDATE_SERVICING_CLIENT_WITH_DEPOSIT", { servicingClientName: distinctServicingClient.displayName })
                                : this.$translate.instant("MESSAGE_UPDATE_SERVICING_CLIENT");

                            this.$appointmentBookModal.showMessage(message, {
                                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                                callback: (result) => {
                                    const isUpdating = result === Meevo.Model.MessageBoxButtonResult.Yes;

                                    if (isUpdating && anyServiceClientHasDeposit) {
                                        this.currentDetail.suppressDepositPrompt = true;
                                    }

                                    updateServicingClientType(isUpdating);
                                }
                            });
                        }
                    }
                } else {
                    continueLogic();
                }
            }

            let payingClientChanged = () => {
                if (this.currentAppointment.payingClient.id) {
                    this.currentAppointment.payingClientType = Meevo.Model.ClientTypeEnum.Client;

                    this.hasPayingClientAlert();

                    if (!this.currentDetail.clientType || (this.currentDetail.clientType === Meevo.Model.ClientTypeEnum.Client && !this.currentDetail.client)) {
                        updateServicingClient(true);
                    } else {
                        const distinctServicingClient = this.getDistinctServicingClient();

                        if (distinctServicingClient &&
                            (distinctServicingClient.clientType !== Meevo.Model.ClientTypeEnum.Client ||
                            (distinctServicingClient.clientType === Meevo.Model.ClientTypeEnum.Client &&
                             distinctServicingClient.clientId !== this.currentAppointment.payingClient.id))) {

                            const anyServiceClientHasDeposit = this.anyServicingClientHasDeposit();
                            const message = anyServiceClientHasDeposit
                                ? this.$translate.instant("MESSAGE_UPDATE_SERVICING_CLIENT_WITH_DEPOSIT", { servicingClientName: distinctServicingClient.displayName })
                                : this.$translate.instant("MESSAGE_UPDATE_SERVICING_CLIENT");

                            this.$appointmentBookModal.showMessage(message, {
                                buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                                callback: (result) => {
                                    const isUpdating = result === Meevo.Model.MessageBoxButtonResult.Yes;

                                    if (isUpdating && anyServiceClientHasDeposit) {
                                        this.currentDetail.suppressDepositPrompt = true;
                                    }

                                    updateServicingClient(isUpdating);
                                }
                            });
                        } else {
                            if (this.currentAppointment.payingClient) {
                                this.checkForClientMissingFieldAlert(this.currentAppointment.payingClient.id, this.payingClientAlerts);
                            }
                            continueLogic();
                        }
                    }
                } else {
                    continueLogic();
                }
            }

            if (changeType === "ClientType") {
                payingClientTypeChanged();
            } else if (isObject(this.currentAppointment.payingClient)) {
                payingClientChanged();
            }

            this.getPayingClientNotes(this.currentAppointment.payingClient);
        }

        private checkForClientMissingFieldAlert(id, clientAlertsArray, isServicingClient: boolean = false) {
            if (!id) { // check if id is null or undefined or empty
                return;
            }

            let uri = '/api/Client/' + id + '/Alerts/?includeNoteCount=false&includeGiftCardCount=false';
            this.dataService.customMethodData(uri, "GET", null)
                .then((response) => {
                    $.each(response.data, (index, alertmsg) => {
                        if (alertmsg.clientAlertType === Meevo.Model.ClientAlertTypeEnum.HasNotes || alertmsg.clientAlertType === Meevo.Model.ClientAlertTypeEnum.HasActiveGiftCard) {
                            return;
                        }
                        clientAlertsArray.push(<PassiveAlert>{
                            alertMessage: this.clientAlertMsg[alertmsg.clientAlertType],
                            alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                            alertClick: () => {
                                if (this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                                    if (this.clientReadPermission && this.clientWritePermission) {
                                        this.goToState("client", Meevo.Model.MaintenanceFormState.Editing, id, "SECTION_CLIENT_MAIN", alertmsg.clientAlertType, (isServicingClient) ? this.clientCallback : this.payingClientCallback);
                                    } else {
                                        this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, id, "SECTION_CLIENT_MAIN", alertmsg.clientAlertType, (isServicingClient) ? this.clientCallback : this.payingClientCallback);
                                    }
                                } else {
                                    this.modalService.alert("ERROR_HTTP_403");
                                }
                            }
                        });
                    });
                    if (this.currentAppointment.payingClient && this.currentDetail.client) {
                        if (this.currentAppointment.payingClient.id == this.currentDetail.client.id) {
                            this.payingClientAlerts = this.clientAlerts = clientAlertsArray;
                        }
                    }

                    // Since these general alerts can be corrected and thus removed without actually
                    // refreshing all the alerts, need to know whether to hide the alert container
                    // based on whether there's any other types of alerts (specific)
                    if (!_(this.payingClientAlerts).any() && !this.payingClientHasSpecificAlert) {
                        this.hidePayingClientAlerts();
                    }
                    if (!_(this.clientAlerts).any() && !this.servicingClientHasSpecificAlert) {
                        this.hideServicingClientAlerts();
                    }
                });
        }

        private openClientPoints(client) {
            this.goToState("clientPoint", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_MAIN", undefined, undefined, client.displayName);
        }

        private openClientAccount(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_HISTORY", undefined, undefined, client.displayName, "ACCOUNT_HISTORY");
        }

        private openMembershipManager(client) {
            this.goToState("membershipManager", Meevo.Model.MaintenanceFormState.Readonly, client.clientMembershipId, "SECTION_MEMBERSHIPMANAGER_MAIN");
        }

        private openGiftCardHistory(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_HISTORY", undefined, undefined, client.displayName, "GIFTCARD_HISTORY");
        }

        private openPackageHistory(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_HISTORY", undefined, undefined, client.displayName, "PACKAGE_HISTORY");
        }

        private openCancelledOrNoShowAppointmentHistory(client) {
            this.goToState("client",
                Meevo.Model.MaintenanceFormState.Readonly,
                client.id,
                "SECTION_HISTORY",
                undefined,
                undefined,
                client.displayName,
                "APPOINTMENT_HISTORY",
                Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.NoShowAndCancelled);
        }

        private goToState(stateName, actionState, id: any = undefined, initialSection = "Main", clientAlertType: any = undefined, callback = undefined, clientDisplayName = null, initialSubSection: string = null, filter: number = undefined) {
            this.$rootScope.$broadcast("gotoState", {
                stateName: stateName,
                stateParams: {
                    callback: callback,
                    callbackState: "appointmentBook",
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionState,
                    id: id,
                    initialEditSection: initialSection,
                    initialEditSubSection: initialSubSection,
                    clientDisplayName: clientDisplayName,
                    filter: filter
                },
                clientAlertType: clientAlertType
            });
        }
        private clientCallback = (currentDetail) => {
            this.clientAlerts = [];
            if (currentDetail) {
                this.checkForClientMissingFieldAlert(currentDetail.id, this.clientAlerts, true);
            }
        }
        private payingClientCallback = (currentDetail) => {
            this.payingClientAlerts = [];
            if (currentDetail) {
                this.checkForClientMissingFieldAlert(currentDetail.id, this.payingClientAlerts);
            }
        }

        private isAnonymous(obj, objType) {
            return (isObject(obj) &&
                (objType === Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                    objType === Meevo.Model.ClientTypeEnum.AnonymousMale ||
                    objType === Meevo.Model.ClientTypeEnum.AnonymousOther));
        }

        canEditPayingClient() {
            return !this.isAnonymous(this.currentAppointment.payingClient, this.currentAppointment.payingClientType);
        }

        canEditServicingClient() {
            return !this.isAnonymous(this.currentDetail.client, this.currentDetail.clientType);
        }

        private checkClientRestrictedWarning(client) {
            if (client.isRestricted) {
                this.hasServicingClientAlert();
                return this.$appointmentBookModal.showMessage(this.$translate.instant("MESSAGE_CLIENT_RESTRICTED"), { messageClass: "high" }, false);
            } else {
                return this.$q.resolve();
            }
        }

        private getNoteClient(client): Meevo.Plugins.Note.INoteClient {
            if (!client || !client.id) {
                return undefined;
            }

            return {
                entityId: client.id,
                clientId: client.id,
                clientType: ClientTypeEnum.Client,
                clientDisplayName: client.displayName,
            };
        }

        private getNoteService(appointmentService, serviceId: string = undefined): Meevo.Plugins.Note.INoteService {
            if (!appointmentService && !serviceId) {
                return undefined;
            }

            return {
                entityId: serviceId || appointmentService.serviceId,
                serviceId: serviceId || appointmentService.serviceId,
            };
        }

        private getPayingClientNotes(client) {
            const noteClient = this.getNoteClient(client);
            return this.getAggregatedNotesWithCaching(noteClient, null).then(notes => {
                this.payingClientNotes = _(notes).filter(note => note.isClientNote);
            })
        }

        private getServicingClientNotes(client) {
            const noteClient = this.getNoteClient(client);
            return this.getAggregatedNotesWithCaching(noteClient, null).then(notes => {
                this.clientNotes = _(notes).filter(note => note.isClientNote);;
            })
        }

        private getAggregatedNotesWithCaching(
            noteClient: Meevo.Plugins.Note.INoteClient,
            noteServices: Meevo.Plugins.Note.INoteService[]
        ): ng.IPromise<Meevo.Plugins.Note.INote[]> {
            if (!noteClient && !noteServices) {
                return this.$q.resolve([]);
            }

            const noteViewTime = Meevo.Model.ClientNoteViewTimeEnum.AppointmentBooked;

            // preserve existing client-only caching
            // caching multiple notes with mixed promises and non-promises gets a bit convoluted

            let cacheKey = undefined;
            if (noteClient && !noteServices)
            {
                cacheKey = `${noteClient.clientId}|${noteViewTime}`;
                const cacheNotes = <ng.IPromise<Meevo.Plugins.Note.INote[]>>this.allAggregatedNotes[cacheKey];

                if (cacheNotes) {
                    return cacheNotes;
                }
            }

            const deferred = this.$q.defer<Meevo.Plugins.Note.INote[]>();
            if (cacheKey) {
                this.allAggregatedNotes[cacheKey] = deferred.promise;
            }

            const noteClients = noteClient ? [ noteClient ] : undefined;

            this.meevoNoteService.loadAggregatedNotes(null, noteClients, noteServices, noteViewTime).then((response) => {
                const clientNotes = this.meevoNoteService.parseAggregatedNotes(response.data, noteClient);

                // If cacheKey exists, besed on the `if` statement above, we can be reasonably sure that there are no `noteServices`,
                // so the logic of processing `noteServices` is fully inside the `else` block.
                // If the above `if` condition ever changes, this logic might also need to be modified accordingly.
                if (cacheKey) {
                    deferred.resolve(clientNotes);
                }
                else {
                    const serviceNotes = [];

                    if (noteServices) {
                        for (const noteService of noteServices) {
                            const formattedNotes = _(this.meevoNoteService.parseAggregatedNotes(response.data, noteService)).sortBy("isTenantOrOwnedServiceNote");
                            serviceNotes.push(...formattedNotes);
                        }
                    }

                    const aggregatedNotes = [ ...clientNotes, ...serviceNotes ];

                    deferred.resolve(aggregatedNotes);
                }
            });

            return deferred.promise;
        }

        private checkBookingTimeClientNotes(client: any) {
            if (!client || !client.id) {
                return this.$q.resolve();
            }

            // if there is more than 1 service for this client, then don't show notes
            const clientServices = this.getClientServices(this.currentAppointment.services, this.currentDetail.client);
            if (clientServices.length > 1) {
                return this.$q.resolve();
            }

            const noteClient = this.getNoteClient(client);

            const noteServices = clientServices.length === 1
                ? [ this.getNoteService(clientServices[0]) ]
                : undefined;

            // add the service add-ons
            if (noteServices && clientServices[0].serviceAddOns) {
                for (const serviceAddOn of clientServices[0].serviceAddOns) {
                    noteServices.push(this.getNoteService(undefined, serviceAddOn.addOnServiceId));
                }
            }

            return this.getAggregatedNotesWithCaching(noteClient, noteServices).then(aggregatedNotes => {
                return this.actions.displayAggregatedNotes(aggregatedNotes, Meevo.Model.ClientNoteViewTimeEnum.AppointmentBooked, false, true);
            });
        }

        private checkPayingClientCardOnFile(client, payingClientChanged)
        {
            if (!payingClientChanged || !this.clientCreditCardReadPermission) {
                return this.$q.resolve();
            }

            return this.getPayingClientCardOnFile(client).then(() =>
            {
                if (!this.globals.businessInfo.promptForCardOnFileWhenBookingAppointments ||
                    _(this.payingClientPaymentAccounts).any(card => !card.isExpired)) {
                    return this.$q.resolve();
                }

                return this.modalService.confirmHandler("MESSAGE_NO_CARD_ON_FILE").then(messageResponse =>
                {
                    if (messageResponse) {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                            stateName: "client",
                            stateParams: {
                                callbackState: this.$state.current.name,
                                callback: this.payingClientCardOnFileChanged,
                                targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                                actionState: Meevo.Model.MaintenanceFormState.Readonly,
                                initialEditSection: "SECTION_CLIENT_CREDIT_CARD",
                                clientDisplayName: client.lastName + ", " + client.firstName,
                                id: client.id
                            },
                        });
                    }
                });
            });
        }

        private getPayingClientCardOnFile(client) {
            let request = {
                criteria: {
                    isApproved: true,
                    clientIds: [client.id],
                    IncludeClientPaymentAccounts: true,
                    IncludeMembershipPaymentAccounts: true
                }
            };

            return this.dataService.customMethodData(`api/PaymentAccount/List`, 'POST', request)
                .then((response) =>
                {
                    this.payingClientPaymentAccounts = response.data;
                    this.payingClientCardsOnFile = _(this.payingClientPaymentAccounts).where({ isClientPaymentAccount: true });
                });
        }

        private getClientCardOnFile(clientId) {
            let request = {
                criteria: {
                    isApproved: true,
                    clientIds: clientId,
                    IncludeClientPaymentAccounts: true
                }
            };

            return this.dataService.customMethodData(`api/PaymentAccount/List`, 'POST', request)
                .then((response) => {
                    _([...this.currentAppointment.services, this.currentDetail]).filter(appointmentService =>
                        appointmentService.client && appointmentService.client.id === clientId).forEach(appointmentService => {
                            appointmentService.client.clientCardsOnFile = [...response.data];
                        });
                });
        }

        private checkClientMembershipCreditCardZipMissing(client) {
            if (!this.globals.businessInfo.clientCCFileMissingZipCode) {
                return this.$q.resolve();
            }

            if (!client || !client.id) {
                return this.$q.resolve();
            }

            let request = {
                criteria: {
                    isApproved: true,
                    clientIds: [client.id],
                    IncludeClientPaymentAccounts: false,
                    IncludeMembershipPaymentAccounts: true
                }
            };

            return this.dataService.customMethodData(`api/PaymentAccount/List`, "POST", request).then((response) => {
                const paymentAccounts = response.data;

                const isZipMissing = _(paymentAccounts).any(x => !x.zipCode || x.zipCode.length === 0 || x.zipCode === '');

                if (!isZipMissing) {
                    return this.$q.resolve();
                }

                const message = [];

                message.push('<div>');
                message.push(this.$translate.instant("MESSAGE_CLIENT_MEMBERSHIP_CREDIT_CARD_ZIP_MISSING"));
                message.push('</div>');
                message.push('<br>');
                message.push(`<div>${client.lastName}, ${client.firstName}</div>`);

                return this.$appointmentBookModal.showMessage(message.join(''), { messageClass: "high" });
            });
        }

        private checkClientBirthday(client) {
            let years = [moment().year() - 1, moment().year(), moment().year() + 1];
            if (client.birthMonth && client.birthDay) {
                years.forEach((year) => {
                    let birthDate = moment().month(client.birthMonth - 1).date(client.birthDay).year(year);
                    if (birthDate >= moment().subtract(15, 'days') &&
                        birthDate <= moment().add(15, 'days')) {

                        var toast = this.$mdToast.simple();
                        let content = client.firstName + "'s birthday ";

                        if (birthDate < moment().startOf('day')) {
                            content += "was";
                        } else {
                            content += "is";
                        }

                        content += ": " + birthDate.format("dddd, MMMM D");

                        toast.textContent(content);
                        toast.position("top right");
                        toast.hideDelay(3000);
                        toast.parent(angular.element("div#editor_header"));
                        toast.theme("success-toast");

                        this.$mdToast.show(toast);
                    }
                });
            }
        }
        private checkImplicitAdd(obj: any = undefined) {
            if (obj == undefined) {
                obj = this.currentDetail;
            }
            if (_.where(this.currentAppointment.services, { id: obj.id }).length === 0 &&
                isObject(obj.service)
                && (isObject(obj.client) ||
                    ((obj.clientType === Meevo.Model.ClientTypeEnum.AnonymousMale ||
                        obj.clientType === Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                        obj.clientType === Meevo.Model.ClientTypeEnum.AnonymousOther)))) {
                this.currentAppointment.services.push(obj);
            }
        }

        employeeChanged() {
            this.currentDetail.stepOverrideStage = Meevo.Model.StepOverrideStageEnum.None;
            this.employeeHasChanged = true;
            if (this.currentDetail.service) {
                this.setState(this.currentDetail, Meevo.Model.StateEnum.Edit);
                this.rebuildSteps(this.currentDetail, false);
            }
            this.updateRequestedState();
            this.refreshServiceCriteria();
            this.$rootScope.$apply();
        }

        updateAmPmSelector(originalStartTime: any) {
            const currentDetailHours = this.currentDetail.startTimeSegmented.value.getHours();
            let adjustHours = 12;

            if (originalStartTime.getHours() === currentDetailHours || Math.abs(originalStartTime.getHours() - currentDetailHours) === 12
                || !_(this.updateAmPmTriggerHours).contains(currentDetailHours)) {

                    return;
            }

            if (currentDetailHours > 12) {
                adjustHours *= -1;
            }

            this.currentDetail.startTime = this.currentDetail.startTimeSegmented.value = moment(this.currentDetail.startTimeSegmented.value).add('h', adjustHours).toDate();
            this.currentDetail.startDateTime = this.getDateTime(this.currentDetail);

            $(`div[name=${this.amPmIdentifier}]`).removeClass('am-pm-pulse');
            this.$timeout(() => $(`div[name=${this.amPmIdentifier}]`).addClass('am-pm-pulse'), 0, true);
        }

        currentDetailTimeChanged() {
            let timerPickerDateTime = moment(this.currentDetail.startTimeSegmented.value.getHours() + ":" + this.currentDetail.startTimeSegmented.value.getMinutes(), "h:m a").toDate();
            //due to timePicker triggerring this function twice, we need to skip second call when time is already set. (Need to rebuild datetime since timePicker adds seconds when is rendered)
            if (moment(this.currentDetail.startTime).isSame(timerPickerDateTime)) {
                return;
            }

            this.currentDetail.isImplicitTimeUpdate = false;
            let updateAll = this.globals.businessInfo.moveServicesAsGroup && this.isFirstServiceFollowedByAllContiguousServicesForSameClient(this.currentDetail);
            const originalStartTime = Object.assign(this.currentDetail.startTime, {});
            this.currentDetail.startTime = timerPickerDateTime;
            this.currentDetail.startDateTime = this.getDateTime(this.currentDetail);
            this.setState(this.currentDetail, Meevo.Model.StateEnum.Edit);

            if (this.globals.isAmPmFormat) {
                this.updateAmPmSelector(originalStartTime);
            }

            this.updateResources(this.currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: true })
                .then((resourceValid) => {
                    this.checkEquipment(this.currentDetail, this.currentDetail.isEquipmentRequired, resourceValid);
                });

            if (updateAll) {
                let previousAppointmentService;
                for (let appointmentService of this.currentAppointment.services) {
                    if (previousAppointmentService) {
                        const proposedStartTime = this.getAppointmentServiceEndDateTime(previousAppointmentService).toDate();
                        if (appointmentService.startDate.getDate() !== moment(proposedStartTime).date()) {
                            const index = this.currentAppointment.services.indexOf(appointmentService);

                            this.currentAppointment.services.slice(index).forEach(service => service.isImplicitTimeUpdate = false);
                            this.modalService.alert('MESSAGE_APPOINTMENT_EDITOR_UNABLE_TO_MOVE_ALL_SERVICES');
                            break;
                        }
                        appointmentService.startTime = proposedStartTime;
                        appointmentService.startTimeSegmented = this.getStartTimeSegmented(moment(appointmentService.startTime));
                        appointmentService.startDateTime = this.getDateTime(appointmentService);
                        appointmentService.isImplicitTimeUpdate = true;
                    }
                    previousAppointmentService = appointmentService;
                }
            }

            const serviceId = this.currentDetail.service ? this.currentDetail.service.id : null;
            const employeeId = this.currentDetail.employee ? this.currentDetail.employee.id : null;
            const clientId = this.currentDetail.client ? this.currentDetail.client.id : null;

            this.updateSingleServicePrice(this.currentDetail, serviceId, employeeId, clientId);
        }

        isFirstServiceFollowedByAllContiguousServicesForSameClient(editedAppointmentService) {
            let isTrue = this.currentAppointment.services[0] == editedAppointmentService;
            let previousAppointmentService;
            if (isTrue) {
                this.currentAppointment.services.forEach(appointmentService => {
                    appointmentService.clientId = appointmentService.client ? appointmentService.client.id : appointmentService.clientId;
                    if (previousAppointmentService &&
                        (this.getAppointmentServiceEndDateTime(previousAppointmentService).format() != moment(appointmentService.startDateTime).format() ||
                            previousAppointmentService.clientId != appointmentService.clientId || previousAppointmentService.clientType != appointmentService.clientType)) {
                        isTrue = false;
                    }
                    previousAppointmentService = appointmentService;
                });
            }
            return isTrue;
        }

        dateChanged() {
            this.currentDetail.startDateTime = this.getDateTime(this.currentDetail);
            for (let appointmentService of this.currentAppointment.services) {
                appointmentService.resources = undefined;
                appointmentService.startDateTime = this.getDateTime(appointmentService);
                appointmentService.startTime = appointmentService.startDateTime;
                appointmentService.startDate = moment(appointmentService.startDateTime).startOf('day').toDate();
            }

            const overrideExisting = !!this.currentAppointment.services && this.currentAppointment.services.length > 0;

            this.updateResources(this.currentDetail, { refreshResourcesIfNotEmpty: true, overrideExistingResource: overrideExisting })
            .then((resourceValid) => {
                this.checkEquipment(this.currentDetail, this.currentDetail.isEquipmentRequired, resourceValid);
            });
    }

        getChromeVersion() {
            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            return raw ? parseInt(raw[2], 10) : false;
        }

        resourceChanged() {
            this.resourceHasChanged = true;
            this.currentDetail.resourceUnitId = undefined;
            if (this.currentDetail.resource) {
                this.currentDetail.resourceId = this.currentDetail.resource.id;
                this.currentDetail.resourceUnitId = this.currentDetail.resource.unitId;
            }
            this.refreshServiceCriteria();
        }

        employeeRequired(service = undefined) {
            service = service || this.currentDetail;
            if (!service) {
                return false;
            }

            if (this.globals.isEmployeeView) {
                return _(service.steps).any(step =>
                    step.durationWithAddOnsInMinutes > 0 &&
                    step.serviceStepType !== Meevo.Model.ServiceStepTypeEnum.Gap &&
                    step.serviceStepType !== Meevo.Model.ServiceStepTypeEnum.Resource)
            }

            return !this.currentDetail.employee && !this.currentDetail.resource;
        }

        resourceRequired() {
            if (this.currentDetail) {
                return (!this.currentDetail.employee && !this.currentDetail.resource) || this.currentDetail.isResourceRequired;
            }
            return false;
        }

        setState(obj, newState) {
            if (newState === Meevo.Model.StateEnum.Edit && obj.stateEnum === Meevo.Model.StateEnum.Read) {
                obj.stateEnum = newState;
            }
        }

        showClientHistory() {
            this.$appointmentBookModal.showClientHistory(this.currentDetail.client.id);
        }

        sendToTransactionHistory() {
            this.$appointmentBookModal.sendToTransactionHistory(this.currentDetail.client, "SECTION_HISTORY",
                this.globals.businessInfo.enableIntegratedRegister ? "TRANSACTION_HISTORY" : "APPOINTMENT_HISTORY");
        }

        showChangeLog() {
            this.$appointmentBookModal.showAppointmentAuditLog(this.currentAppointment.id);
        }

        serviceInformation() {
            this.$appointmentBookModal.serviceInformation(this.currentDetail.service.id);
        }

        showServiceStepsModal() {
            this.$appointmentBookModal.showSteps(this.currentDetail, this.currentAppointment, this.isReadOnly).then(() => {
                this.calculateStepDuration(this.currentDetail);
            });
        }

        private showServiceAddOnsModal(currentDetail, isAutomated: boolean = false) {
            return this.showServiceAddOns(
                currentDetail.service.id,
                currentDetail.employee ? currentDetail.employee.id : undefined,
                currentDetail.client ? currentDetail.client.id : undefined,
                currentDetail.isNew ? null : currentDetail.id,
                isAutomated
            );
        }

        showServiceAddOns(serviceId, employeeId, clientId, appointmentServiceId, isAutomated: boolean = false) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/serviceAddOns.html",
                controller: "meevo.plugins.appointmentBook.ServiceAddOnsController",
                bindToController: true,
                locals: {
                    clientId: clientId,
                    serviceId: serviceId,
                    serviceDisplayName: this.currentDetail.service.displayName,
                    employeeId: employeeId,
                    currentServiceAddOns: this.currentDetail.serviceAddOns,
                    finalState: this.currentDetail.finalState,
                    transitionState: this.currentDetail.transitionState,
                    isReadOnly: this.isReadOnly,
                    isFromWalkIn: false,
                    isAutomated: isAutomated,
                    equipmentValidator: this,
                    yieldManagementDateTime: this.currentDetail.startDateTime,
                    applyProductUsage: true,
                    appointmentServiceId: appointmentServiceId
                },
                controllerAs: "vm"
            };

            return this.modalService.showCustom(options, Components.Modal.ModalTranslationModes.DoNotTranslate, true).then(response => {
                switch (response.action) {
                    case 'save':
                        const addOns = response.data;
                        addOns.forEach(addOn => {
                            addOn.appointmentServiceId = this.currentDetail.id;
                        });
                        this.currentDetail.serviceAddOns = addOns;
                        this.currentDetail.totalPrice = this.calculatePrice(this.currentDetail);
                        break;
                    case 'close':
                    case 'cancel':
                        const hasRequired = response.data;
                        if (isAutomated && hasRequired) {
                            this.currentDetail.service = undefined;
                            this.serviceChanged();
                        }
                        break;
                }
                this.calculateStepDuration(this.currentDetail);
            })
        }

        public calculateStepDuration(appointmentService) {
            this.stepOverrideService.calculateStepDuration(appointmentService);
        }

        getTransworldDetail(membership: any, returnStr): string {
            if (!membership) {
                return "";
            }

            const getReturnStr = (className, iconFilename, contentKey) => {
                switch (returnStr) {
                    case 0:
                        return className;
                    case 1:
                        return "assets/images/icons/" + iconFilename;
                    case 2:
                        return this.$translate.instant(contentKey);
                }
                return null;
            }

            return getReturnStr("", "transworld.svg", "LABEL_TOOLTIP_SEND_TO_TRANSWORLD");
        }

        isGenderPreferenceRequired() {
            return this.globals
                && this.globals.businessInfo
                && this.globals.businessInfo.useGenderPreferenceWhenBookingAppointments
                && this.currentDetail
                && this.currentDetail.allowGenderPreference
                && this.canEdit();
        }

        appointmentEditorMinimize() {
            $('#editor_minimized').show();
            $('#editor_maximized').hide();
            $('.side-main-container').addClass('side-main-container-minimized');

            this.actions.CheckForAdjustEditor();
            this.unbindHotkeys();
        }

        appointmentEditorMaximize() {
            $('#editor_minimized').hide();
            $('#editor_maximized').show();
            $('.side-main-container').removeClass('side-main-container-minimized');
            window.focus();

            this.actions.CheckForAdjustEditor();
            this.bindHotkeys();
        }

        getCleanupStepDuration(previousAppointmentService) {
            return previousAppointmentService && _(previousAppointmentService.steps).last().isCleanupStep ?
                _(previousAppointmentService.steps).last().durationWithAddOnsInMinutes :
                0;
        }

        private bindHotkeys(): void {
            const currentGroup = this.shortCutsService.getGroupByIndex(GroupLevels.Plugin);
            if (currentGroup) {
                currentGroup.removeShortCuts(['APPOINTMENT_BOOK_SAVE', 'APPOINTMENT_BOOK_CANCEL', 'APPOINTMENT_BOOK_DELETE']);
                currentGroup.addShortCuts([
                    {
                        shortCutName: 'APPOINTMENT_BOOK_SAVE', callback: () => this.$timeout(() => {
                            angular.element('#app-book-save-button').triggerHandler('click');
                        }, 0)
                    },
                    {
                        shortCutName: 'APPOINTMENT_BOOK_CANCEL', callback: () => this.$timeout(() => {
                            angular.element('#app-book-cancel-button').triggerHandler('click');
                        }, 0)
                    },
                    {
                        shortCutName: 'APPOINTMENT_BOOK_DELETE', callback: () => this.$timeout(() => {
                            angular.element('#app-book-delete-button').triggerHandler('click');
                        }, 0)
                    },
                ]);

                this.shortCutsService.activateGroup(currentGroup);
            }
        }

        public unbindHotkeys(): void {
            const currentGroup = this.shortCutsService.getGroupByIndex(GroupLevels.Plugin);
            if (currentGroup) {
                currentGroup.removeShortCuts(['APPOINTMENT_BOOK_SAVE', 'APPOINTMENT_BOOK_CANCEL', 'APPOINTMENT_BOOK_DELETE']);
                this.shortCutsService.del(['APPOINTMENT_BOOK_SAVE', 'APPOINTMENT_BOOK_CANCEL', 'APPOINTMENT_BOOK_DELETE']);
            }
        }

        cancelEditor() {
            this.actions.closeEditor();
            this.helper.checkReturnToState(this, false);
        }

        private updateRequestedState(targetService = null, additionalServices = []) {
            targetService = targetService || this.currentDetail;

            if (!targetService.employee || !targetService.client) {
                return;
            }

            var otherClientEmployeeServices = [...this.currentAppointment.services, ...additionalServices].filter(service =>
                service.id !== targetService.id &&
                (targetService.client.id ?
                    service.client.id === targetService.client.id :
                    service.clientType === targetService.clientType) &&
                service.employee.id.equals(targetService.employee.id)
            );

            if (otherClientEmployeeServices.length < 1) {
                targetService.isRequested = this.setIsRequested();
                return;
            }

            if (_(otherClientEmployeeServices).any(service => service.isRequested)) {
                targetService.isRequested = true;
                return;
            }

            if (_(otherClientEmployeeServices).any(service => service.isRequested === false)) {
                targetService.isRequested = false;
                return;
            }

            targetService.isRequested = undefined;
        }

        private updateResourceSharingServicesRequestStatus(validServices: any[]): void {
            var uncreatedServices = validServices.filter(validService =>
                !_(this.currentAppointment.services).findWhere({ id: validService.id} ));
            var servicesToUpdateRequestStatus = [...uncreatedServices, ...validServices.filter(validService => {
                const matchedService = _(this.currentAppointment.services).findWhere({ id: validService.id} );
                return matchedService && (matchedService.employee.id !== validService.employee.id ||
                    matchedService.client.id !== validService.client.id);
            })];

            servicesToUpdateRequestStatus.forEach(service => this.updateRequestedState(service, uncreatedServices));
        }


        static factory(): Function {
            let svc = (
                restServer,
                modal,
                helper,
                actions,
                rootScope,
                $translate,
                busyService,
                securityChecker,
                $mdToast,
                globals,
                dataService,
                $q,
                modalService,
                identityService,
                filterActions,
                shortCutsService,
                $timeout,
                recentService,
                roundingService,
                stepOverrideService,
                appointmentNoteService,
                $state,
                meevoMessengerApiService,
                membershipDetailsService,
                $compile,
                referralService,
                noteService
            ) => new AppointmentEditorService(
                restServer,
                modal,
                helper,
                actions,
                rootScope,
                $translate,
                busyService,
                securityChecker,
                $mdToast,
                globals,
                dataService,
                $q,
                modalService,
                identityService,
                filterActions,
                shortCutsService,
                $timeout,
                recentService,
                roundingService,
                stepOverrideService,
                appointmentNoteService,
                $state,
                meevoMessengerApiService,
                membershipDetailsService,
                $compile,
                referralService,
                noteService
            );

            svc.$inject = [
                'restServer',
                'appointmentBookModalService',
                'appointmentBookHelperService',
                'appointmentBookActionsService',
                '$rootScope',
                '$translate',
                'meevo.components.busy.BusyService',
                'meevo.components.common.SecurityService',
                '$mdToast',
                'appointmentBookGlobalsService',
                'meevo.components.common.DataService',
                '$q',
                'meevo.components.modal.ModalService',
                'meevo.components.common.IdentityService',
                'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
                'meevo.components.short-cuts.ShortCutsService',
                '$timeout',
                'meevo.components.common.RecentService',
                'meevo.components.common.RoundingService',
                'meevo.plugins.appointmentBook.stepOverrideService',
                'meevo.plugins.appointmentBook.AppointmentNoteService',
                '$state',
                'meevo.plugins.meevoMessenger.meevoMessengerApiService',
                'meevo.components.common.MembershipDetailsService',
                '$compile',
                'meevo.plugins.referral.ReferralService',
                'meevo.plugins.note.NoteService',
            ];

            return svc;
        }
    }

    angular.module("ApptBookApp")
        .service("AppointmentEditorService", AppointmentEditorService.factory());
}
